import React, { ChangeEvent, MutableRefObject, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CalenderIcon from "../../../svg/Ads_Dashboard_Developement2/CalenderIcon/elements.svg";
import ExportIcon from "../../../svg/Ads_Dashboard_Developement2/ExportIcon/elements.svg";
import DragAndDropIcon from "../../../svg/Ads_Dashboard_Developement2/Drag_and_Drop_Icon/elements.svg";
import { startOfWeek } from "date-fns";
import DateRangeComponent from "../../commonComponents/SummaryDateRangeComponent/DateRangeComponent 1";
import MultiSelect from "../../commonComponents/MultiSelect";
import {
  downloadCSV,
  // formatCurrentDate,
  formatDate,
  formatDatefunc,
  formatMonthYear,
  formatToDDMMYYYY,
  formatWeekInput,
  formatWeekInputForCsv,
  getFormattedValue,
  getMonthsInRange,
  getYearsFromGivenRange,
} from "../../../appFunctions";
import { BASE_URL, BLACK, WHITE } from "../../../appConstants";
import {
  Button,
  CircularProgress,
  DialogContent,
  Drawer,
  Input,
  Option,
  Select,
  selectClasses,
  Switch,
} from "@mui/joy";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";
import appError from "../../../appError";
import { useSelector } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";
import { logDOM } from "@testing-library/react";
import OverviewSummaryCustomExportModal from "../../commonComponents/Ads_Dashboard_Cmps/Summary Components/Export Functionality/OverviewSummaryCustomExportModal";
import ViewComponent1 from "./Summary_View_Cmps/ViewComponent1";
import ViewComponent2 from "./Comparison_View_Cmps/ViewComponent2";

type DateProps = {
  startDate: Date;
  endDate: Date;
};
type RangeProps = {
  min_date: Date;
  max_date: Date;
};
type MonthProps = {
  id: string;
  label: string;
};
type YearProps = {
  id: string;
  label: string;
};
type WeekProps = [number, number];
type FilterProps = {
  filter_type: string;
  type: string;
  month: number[];
  year: number[];
  week: WeekProps[];
  start_date: Date;
  end_date: Date;
};
type DataProps = {
  [key: string]: any;
};
type DynamicObject = {
  [key: string]: any;
};
type Matrice = {
  id: number;
  matrice_name: string;
  backend_matrice_name: string;
  toggle: boolean;
  position: number;
};
const OverviewSummaryPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [dateToggle, setDateToggle] = useState<boolean>(false);
  const [range, setRange] = useState<RangeProps>({} as RangeProps);

  // const getDateMinusDays = (days: number): string => {
  //   // Create a new Date instance for today
  //   const today = new Date();

  //   // Subtract the specified number of days
  //   today.setDate(today.getDate() - days);

  //   // Format the date as a string (e.g., YYYY-MM-DD)
  //   const formattedDate = today.toISOString().split("T")[0];
  //   return formattedDate;
  // };

  const getWeekRange = (date: Date) => {
    const todayDate = date.getDate();

    // Define fixed week ranges
    const weeks: [number, number][] = [
      [1, 7],
      [8, 14],
      [15, 21],
      [22, 28],
      [29, 31],
    ];

    // Find the index of the current week
    const currentWeekIndex = weeks.findIndex(
      ([start, end]) => todayDate >= start && todayDate <= end
    );
    if (currentWeekIndex === -1) return null; // Fallback in case no match is found

    // Get the current and previous week's range
    const [currentStart, currentEnd] = weeks[currentWeekIndex];

    return {
      currentWeekStart: new Date(
        date?.getFullYear(),
        date?.getMonth(),
        currentStart
      ),
    };
  };

  const [filter, setFilter] = useState<FilterProps>({
    filter_type: "",
    type: "day",
    month: [],
    year: [],
    week: [],
    start_date: new Date(),
    end_date: new Date(),
  });

  // ------Year
  const [years, setYears] = useState<YearProps[]>([] as YearProps[]);
  const [selectedYears, setSelectedYears] = useState<Set<string>>(new Set([]));

  const onYearChange = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
    let set = new Set(selectedYears);

    if (e.target.checked) {
      if (id === "Select All") {
        years.forEach((m) => set.add(m.id));
        setFilter((prev) => {
          return {
          ...prev,
          filter_type: "SEGMENT",
          year: years
            .filter((m) => m?.id !== "Select All") // Exclude items with id === '13'
            .map((m) => Number(m?.id)), // Convert remaining ids to numbers
          }
        });

      } else if (id !== "Select All") {
        set.add(id);
        setFilter((prev) => ({
          ...prev,
          year: [...prev.year, Number(id)],
          filter_type: "SEGMENT",
        }));
        if (set.size === years.length - 1) {
          set.add("Select All");
        }
      }
    } else {
      if (id === "Select All" && set.size === years.length) {
        set.clear();

        if(filter?.week?.length === 0 && filter?.month?.length === 0){
          setFilter((prev) => ({
            ...prev,
            year: [],
            filter_type: "TIMELINE",
          }));
        }
        else {
          setFilter((prev) => ({
            ...prev,
            year: [],
            filter_type: "SEGMENT",
          }));
        }

      } else if (id !== "Select All") {
        if (set.has("Select All")) {
          set.delete("Select All");
        }
        set.delete(id);

        if(filter?.week?.length === 0 && filter?.month?.length === 0 && set?.size === 0){
          setFilter((prev) => ({
            ...prev,
            year: [],
            filter_type: "TIMELINE",
          }));
        }
        else{
          setFilter((prev) => ({
            ...prev,
            year: prev.year.filter((yearId) => yearId !== Number(id)),
            filter_type: "SEGMENT",
          }));
        }

      }
    }
    setSelectedYears(set);
  };
  // --- End

  // ---- Months
  const [months, setMonths] = useState<MonthProps[]>([] as MonthProps[]);
  const [selectedMonths, setSelectedMonths] = useState<Set<string>>(
    new Set([])
  );
 const onMonthChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    let set = new Set(selectedMonths);
    if (e.target.checked) {
      if (id === "13") {
        months.forEach((m) => set.add(m.id));
        setFilter((prev) => ({
          ...prev,
          filter_type: "SEGMENT",
          month: months
            .filter((m) => m?.id !== "13") // Exclude items with id === '13'
            .map((m) => Number(m?.id)), // Convert remaining ids to numbers
        }));
      } else if (id !== "13") {
        set.add(id);
        setFilter((prev) => ({
          ...prev,
          filter_type: "SEGMENT",
          month: [...prev.month, Number(id)],
        }));
        if (set.size === months.length - 1) {
          set.add("13");
        }
      }
    } else {
      if (id === "13" && set.size === months.length) {
        set.clear();

        if(filter?.year?.length === 0 && filter?.week?.length === 0){
          setFilter((prev) => ({
            ...prev,
            month: [],
            filter_type: "TIMELINE",
          }));
        }
        else {
          setFilter((prev) => ({
            ...prev,
            filter_type: "SEGMENT",
            month: [],
          }));
        }

      } else if (id !== "13") {
        if (set.has("13")) {
          set.delete("13");
        }
        set.delete(id);

        if(filter?.year?.length === 0 && filter?.week?.length === 0 && set?.size === 0){
          setFilter((prev) => ({
            ...prev,
            month: [],
            filter_type: "TIMELINE",
          }));
        }
        else {
          setFilter((prev) => ({
            ...prev,
            filter_type: "SEGMENT",
            month: prev.month.filter((monthId) => monthId !== Number(id)),
          }));
        }

      }
    }
    setSelectedMonths(set);
  };
  // --- End

  // ----- Week
  const [weeks, setWeeks] = useState<MonthProps[]>([
    { id: "6", label: "Select All" },
    { id: "1", label: "Week 1" },
    { id: "2", label: "Week 2" },
    { id: "3", label: "Week 3" },
    { id: "4", label: "Week 4" },
    { id: "5", label: "Week 5" },
  ]);
  const [selectedWeeks, setSelectedWeeks] = useState<Set<string>>(new Set([]));
  const [selweeks, setSelweeks] = useState<WeekProps[]>([]);

  const onWeekChange = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
    let set = new Set(selectedWeeks);
    if (e.target.checked) {
      if (id === "6") {
        weeks.forEach((m) => set.add(m?.id));
        setSelweeks(() => [
          [1, 7],
          [8, 14],
          [15, 21],
          [22, 28],
          [29, 31],
        ]);
      } else if (id !== "6") {
        set.add(id);
        if (set.size === weeks.length - 1) {
          set.add("6");
        }
        if (id === "1") {
          setSelweeks((prev) => [...prev, [1, 7]]);
        } else if (id === "2") {
          setSelweeks((prev) => [...prev, [8, 14]]);
        } else if (id === "3") {
          setSelweeks((prev) => [...prev, [15, 21]]);
        } else if (id === "4") {
          setSelweeks((prev) => [...prev, [22, 28]]);
        } else if (id === "5") {
          setSelweeks((prev) => [...prev, [29, 31]]);
        }
      }
    } else {
      if (id === "6" && set.size === weeks.length) {
        set.clear();
        setSelweeks([]);
      } else if (id !== "6") {
        if (set.has("6")) {
          set.delete("6");
        }
        if (set.has(id)) {
          set.delete(id);
          if (id === "1") {
            setSelweeks((prev) =>
              prev.filter((range) => !(range[0] === 1 && range[1] === 7))
            );
          } else if (id === "2") {
            setSelweeks((prev) =>
              prev.filter((range) => !(range[0] === 8 && range[1] === 14))
            );
          } else if (id === "3") {
            setSelweeks((prev) =>
              prev.filter((range) => !(range[0] === 15 && range[1] === 21))
            );
          } else if (id === "4") {
            setSelweeks((prev) =>
              prev.filter((range) => !(range[0] === 22 && range[1] === 28))
            );
          } else if (id === "5") {
            setSelweeks((prev) =>
              prev.filter((range) => !(range[0] === 29 && range[1] === 31))
            );
          }
        }
      }
    }
    let dummyset = [...set];
    dummyset = dummyset.filter((item) => item !== "6");
    const datesarr: WeekProps[] = [
      [1, 7],
      [8, 14],
      [15, 21],
      [22, 28],
      [29, 31],
    ];
    const weeksarr: WeekProps[] = dummyset.map((i) => datesarr[Number(i) - 1]);
    if(filter?.year?.length === 0 && filter?.month?.length === 0 && weeksarr?.length === 0){
      setFilter((prev) => ({
        ...prev,
        filter_type: "TIMELINE",
        week: [],
      }));
    }
    else {
      setFilter((prev) => ({
        ...prev,
        filter_type: "SEGMENT",
        week: weeksarr,
      }));
    }
    setSelectedWeeks(set);
  };

  // ---- End
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");

  // const onDateChange = ({
  //   target: { value, name },
  // }: React.ChangeEvent<HTMLInputElement>): void => {
  //   if (name === "start") {
  //     setStartDate(value);
  //   } else if (name === "end") {
  //     setEndDate(value);
  //   }
  //   if (startDate && endDate) {
  //     setFilter((prev) => ({
  //       ...prev,
  //       filter_type: "SEGMENT",
  //       week: [[Number(startDate), Number(endDate)]],
  //     }));
  //   }
  // };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let start, end;
    if (e.target.name === "startDate") {
      start = e.target.value;
      setStartDate(e.target.value);
    } else {
      end = e.target.value;
      setEndDate(e.target.value);
    }
    let weeklist: WeekProps[] = [];
    if (startDate && end) {
      weeklist = [[Number(startDate), Number(end)]];
    } else if (start && endDate) {
      weeklist = [[Number(start), Number(endDate)]];
    }
    // else if(startDate !== "" && end === "" || start === "" && endDate !== "" || startDate === "" && endDate === ""){
    //   weeklist = [];
    // }
    if(filter?.year?.length === 0 && filter?.month?.length === 0 && filter?.week?.length > 0 && filter?.filter_type === "SEGMENT"){
      setFilter((prev) => ({
        ...prev,
        filter_type: "TIMELINE",
        week: [],
      }));
    }

    if((startDate && end) || (start && endDate)){
      setFilter((prev) => ({
        ...prev,
        filter_type: "SEGMENT",
        week: weeklist,
      }));
    } 

  };

  const apply = (date: DateProps) => {
    setFilter((prev) => ({
      ...prev,
      filter_type: "TIMELINE",
      start_date: date?.startDate,
      end_date: date?.endDate,
    }));
  };

  // -----AG GRID
  const [matricesData, setMatricesData] = useState<Matrice[]>([]);
  // Drawer
  const [matricesDataDrawer, setMatricesDataDrawer] = useState<Matrice[]>([]);
  const [resetToggle, setResetToggle] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false); // Loader for Table
  const [fetchData, setFetchData] = useState<DataProps[]>([]);
  const [filterdata, setfilterData] = useState<DataProps[]>([]);
  const [columnDefs, setColumnDefs] = useState<ColDef<DataProps>[]>([]);
  const [datafetchingState, setDataFetchingState] = useState<string>("");
  const [errorToggle, setErrorToggle] = useState<boolean>(false);
  const { brand_id } = useParams();
  const { platform_id } = useSelector((state: any) => state.appData);

  const [rowsToggle, setRowsToggle] = useState<boolean>(false);
  const [rsmatricearr, setRsMatricearr] = useState(["cost", "sales", "gross_sales_seller", "gross_sales_vendor", "organic_sales"]);

  const MatriceCellRenderer = (params: any) => {
    const { colDef, data } = params;
    return (
      <div className="flex px-6 py-1 items-center justify-start self-stretch gap-2">
        <div
          className=""
          style={{
            textAlign: "start",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "18px",
          }}
        >
          {data[colDef.field]}
        </div>
      </div>
    );
  };

  const DailyCellRenderer = (params: any) => {
    const { colDef, data } = params;
    return (
      <div className="flex px-6 py-1 items-center justify-end self-stretch gap-2">
        <div
          className=""
          style={{
            textAlign: "center",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "18px",
          }}
        >
          {transposeFormat === "VERTICAL" ? rsmatricearr?.includes(data?.backend_matrice_name) ? `₹ ${getFormattedValue(data[colDef?.field])}` : getFormattedValue(data[colDef.field]) : rsmatricearr?.includes(colDef?.field) ? `₹ ${getFormattedValue(data[colDef?.field])}` : getFormattedValue(data[colDef.field])}
        </div>
      </div>
    );
  };

  const WeekCellRenderer = (params: any) => {
    const { colDef, data } = params;
    return (
      <div className="flex px-6 py-1 items-center justify-end self-stretch gap-2">
        <div
          className=""
          style={{
            textAlign: "center",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "18px",
          }}
        >
           {transposeFormat === "VERTICAL" ? rsmatricearr?.includes(data?.backend_matrice_name) ? `₹ ${getFormattedValue(data[colDef?.field])}` : getFormattedValue(data[colDef.field]) : rsmatricearr?.includes(colDef?.field) ? `₹ ${getFormattedValue(data[colDef?.field])}` : getFormattedValue(data[colDef.field])}

          {/* {getFormattedValue(data[colDef.field])} */}
        </div>
      </div>
    );
  };

  const MonthCellRenderer = (params: any) => {
    const { colDef, data } = params;
    return (
      <div className="flex px-6 py-1 items-center justify-end self-stretch gap-2">
        <div
          className=""
          style={{
            textAlign: "center",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "18px",
          }}
        >
           {transposeFormat === "VERTICAL" ? rsmatricearr?.includes(data?.backend_matrice_name) ? `₹ ${getFormattedValue(data[colDef?.field])}` : getFormattedValue(data[colDef.field]) : rsmatricearr?.includes(colDef?.field) ? `₹ ${getFormattedValue(data[colDef?.field])}` : getFormattedValue(data[colDef.field])}
          {/* {getFormattedValue(data[colDef.field])} */}
        </div>
      </div>
    );
  };

  const AllCellRenderer = (params: any) => {
    const {colDef, data, value} = params;
    return (
      <div className="flex px-6 py-1 items-center justify-end self-stretch gap-2">
        <div
          className=""
          style={{
            textAlign: "center",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "18px",
          }}
        >
           {transposeFormat === "VERTICAL" ? rsmatricearr?.includes(data?.backend_matrice_name) ? `₹ ${getFormattedValue(data?.all)}` : getFormattedValue(data?.all) : rsmatricearr?.includes(colDef?.field) ? `₹ ${getFormattedValue(value)}` : getFormattedValue(value)}
          {/* {getFormattedValue(params?.data?.all)} */}
        </div>
      </div>
    );
  };

  const MatriceNameHeaderCmp = (params: any) => {
    return (
      <div
        className="flex px-6 py-1 items-center justify-end self-stretch gap-2"
        style={{
          backgroundColor: "#F3F3F7",
        }}
      >
        <div
          style={{
            color: "var(--Text-Primary-Black, #1C1C1E)",
            textAlign: "right",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "16px",
          }}
        >
          {params?.displayName}
        </div>
      </div>
    );
  };

  const HeaderCellRenderer = (params: any) => {
    return (
      <div
        className="w-full flex px-6 py-1 items-center justify-end self-stretch gap-2"
        style={{
          backgroundColor: "#F3F3F7",
        }}
      >
        <div
          style={{
            color: "var(--Text-Primary-Black, #1C1C1E)",
            textAlign: "center",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "16px",
          }}
        >
          {params?.displayName}
        </div>
      </div>
    );
  };

  const [rawData, setRawData] = useState<any[]>([]);
  const [agGridTableWidth, setAgGridTableWidth] = useState<number>(0);
  const [transposeFormat, setTransposeFormat] = useState<string>("VERTICAL");

  const onTimelineFilterHandler = async () => {
    const token = localStorage.getItem("token");
    
    const { filter_type, type, start_date, end_date } = filter;
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/getSummery?brand_id=${brand_id}`;
      const result = await axios.post(
        api,
        {
          agg_type: type,
          filter_type,
          start_date: formatDate(start_date),
          end_date: formatDate(end_date),
        },
        { headers }
      );
      const { results, message } = result?.data?.data;
      let new_arr: any[] = [];
      let tablewidth = 200;
      if(transposeFormat === "VERTICAL"){
        let col: ColDef<DataProps>[] = [
          {
            field: "matrices",
            headerName: "Matrices",
            cellRenderer: MatriceCellRenderer,
            headerComponent: MatriceNameHeaderCmp,
            width: 200,
            pinned: 'left'
          },
        ];
        let impressionsObj: DynamicObject = {
          id: 1,
          matrices: "Impressions",
          backend_matrice_name: 'impressions'
        };
        let clicksObj: DynamicObject = {
          id: 2,
          matrices: "Clicks",
          backend_matrice_name: 'clicks'
        };
        let costObj: DynamicObject = {
          id: 3,
          matrices: "Spend",
          backend_matrice_name: 'cost'
        };
        let salesObj: DynamicObject = {
          id: 4,
          matrices: "Ad Sales",
          backend_matrice_name: 'sales'
        };
        let ad_sales_percObj: DynamicObject = {
          id: 5,
          matrices: "Ad Sales %",
          backend_matrice_name: 'ad_sales_perc'
        };
        let gross_sales_sellerObj: DynamicObject = {
          id: 6,
          matrices: "Gross Sales (Seller)",
          backend_matrice_name: 'gross_sales_seller'
        };
        let gross_sales_vendorObj: DynamicObject = {
          id: 7,
          matrices: "Gross Sales (Vendor)",
          backend_matrice_name: 'gross_sales_vendor'
        };
        let organic_salesObj: DynamicObject = {
          id: 8,
          matrices: "Organic Sales",
          backend_matrice_name: 'organic_sales'
        };
        let organic_sales_percObj: DynamicObject = {
          id: 9,
          matrices: "Organic Sales %",
          backend_matrice_name: 'organic_sales_perc'
        };
        let ordersObj: DynamicObject = {
          id: 10,
          matrices: "Ad Orders",
          backend_matrice_name: 'orders'
        };
        let unitsObj: DynamicObject = {
          id: 11,
          matrices: "Ad Units",
          backend_matrice_name: 'units'
        }; 
        let gross_units_sellerObj: DynamicObject = {
          id: 12,
          matrices: "Gross Units (Seller)",
          backend_matrice_name: 'gross_units_seller',
        };
        let gross_units_vendorObj: DynamicObject = {
          id: 13,
          matrices: "Gross Units (Vendor)",
          backend_matrice_name: 'gross_units_vendor',
        };
        let organic_unitsObj: DynamicObject = {
          id: 14,
          matrices: "Organic Units",
          backend_matrice_name: 'organic_units',
        };
        let acosObj: DynamicObject = {
          id: 15,
          matrices: "ACOS",
          backend_matrice_name: 'acos',
        };
        let tacosObj: DynamicObject = {
          id: 16,
          matrices: "TACOS",
          backend_matrice_name: 'tacos',
        };
        let roasObj: DynamicObject = {
          id: 17,
          matrices: "ROAS",
          backend_matrice_name: 'roas',
        };
        let troasObj: DynamicObject = {
          id: 18,
          matrices: "TROAS",
          backend_matrice_name: 'troas',
        };
        let ctrObj: DynamicObject = {
          id: 19,
          matrices: "CTR",
          backend_matrice_name: 'ctr',
        };
        let cvrObj: DynamicObject = {
          id: 20,
          matrices: "CVR",
          backend_matrice_name: 'cvr',
        };
        let cpcObj: DynamicObject = {
          id: 21,
          matrices: "CPC",
          backend_matrice_name: 'cpc',
        };
        let aovObj: DynamicObject = {
          id: 22,
          matrices: "AOV",
          backend_matrice_name: 'aov',
        };
        let cacObj: DynamicObject = {
          id: 23,
          matrices: "CAC",
          backend_matrice_name: 'cac',
        };
        let gross_glanceviewsObj: DynamicObject = {
          id: 24,
          matrices: "Glance View",
          backend_matrice_name: 'gross_glanceviews',
        };
        

        for (let el of results) {
          let {
            date,
            impressions,
            clicks,
            cost,
            sales,
            units,
            ad_sales_perc,
            gross_sales_seller,
            gross_sales_vendor,
            organic_sales,
            organic_sales_perc,
            orders,
            gross_units_seller,
            gross_units_vendor,
            organic_units,
            acos,
            tacos,
            roas,
            troas,
            ctr,
            cvr,
            cpc,
            aov,
            cac,
            gross_glanceviews,
          } = el;
          if (type === "day") {
            col.push({
              field: date,
              headerName: `${formatDatefunc({ date })}`,
              cellRenderer: DailyCellRenderer,
              headerComponent: HeaderCellRenderer,
              width: 150,
            });
            tablewidth += 150;
            impressionsObj[date] = Number(impressions);
            clicksObj[date] = Number(clicks);
            costObj[date] = Number(cost);
            salesObj[date] = Number(sales);
            ad_sales_percObj[date] = Number(ad_sales_perc);
            gross_sales_sellerObj[date] = Number(gross_sales_seller ?? 0);
            gross_sales_vendorObj[date] = Number(gross_sales_vendor ?? 0);
            organic_salesObj[date] = Number(organic_sales);
            organic_sales_percObj[date] = Number(organic_sales_perc);
            ordersObj[date] = Number(orders);
            unitsObj[date] = Number(units);
            gross_units_sellerObj[date] = Number(gross_units_seller ?? 0);
            gross_units_vendorObj[date] = Number(gross_units_vendor ?? 0);
            organic_unitsObj[date] = Number(organic_units);
            acosObj[date] = Number(acos);
            tacosObj[date] = Number(tacos);
            roasObj[date] = Number(roas);
            troasObj[date] = Number(troas);
            ctrObj[date] = Number(ctr);
            cvrObj[date] = Number(cvr);
            cpcObj[date] = Number(cpc);
            aovObj[date] = Number(aov);
            cacObj[date] = Number(cac);
            gross_glanceviewsObj[date] = Number(gross_glanceviews);
          } else if (type === "week") {
            const [year, month, week_name, week] = date?.split("-");
            col.push({
              field: `${formatWeekInputForCsv({ year, month, week })}`,
              headerName: `${formatWeekInput({ year, month, week })}`,
              cellRenderer: WeekCellRenderer,
              headerComponent: HeaderCellRenderer,
              width: 150,
            });
            tablewidth += 150;
            impressionsObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(impressions);
            clicksObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(clicks);
            costObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(cost);
            salesObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(sales);
            ad_sales_percObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(ad_sales_perc);

            gross_sales_sellerObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_sales_seller ?? 0);
            gross_sales_vendorObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_sales_vendor ?? 0);

            organic_salesObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(organic_sales);
            organic_sales_percObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(organic_sales_perc);
            ordersObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(orders);
            unitsObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(units);

            gross_units_sellerObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_units_seller ?? 0);
            gross_units_vendorObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_units_vendor ?? 0);

            organic_unitsObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(organic_units);
            acosObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(acos);
            tacosObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(tacos);
            roasObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(roas);
            troasObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(troas);
            ctrObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(ctr);
            cvrObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(cvr);
            cpcObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(cpc);
            aovObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(aov);
            cacObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(cac);
            gross_glanceviewsObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_glanceviews);
          } else if (type === "month") {
            const [year, month, week_name, week] = date?.split("-");
            col.push({
              field:  `${formatMonthYear({ year, month })}`,
              headerName: `${formatMonthYear({ year, month })}`,
              cellRenderer: MonthCellRenderer,
              headerComponent: HeaderCellRenderer,
              width: 150,
            });
            tablewidth += 150;
            impressionsObj[ `${formatMonthYear({ year, month })}`] = Number(impressions);
            clicksObj[ `${formatMonthYear({ year, month })}`] = Number(clicks);
            costObj[ `${formatMonthYear({ year, month })}`] = Number(cost);
            salesObj[ `${formatMonthYear({ year, month })}`] = Number(sales);
            ad_sales_percObj[ `${formatMonthYear({ year, month })}`] = Number(ad_sales_perc);

            gross_sales_sellerObj[`${formatMonthYear({ year, month })}`] = Number(gross_sales_seller ?? 0);
            gross_sales_vendorObj[`${formatMonthYear({ year, month })}`] = Number(gross_sales_vendor ?? 0);

            organic_salesObj[ `${formatMonthYear({ year, month })}`] = Number(organic_sales);
            organic_sales_percObj[ `${formatMonthYear({ year, month })}`] = Number(organic_sales_perc);
            ordersObj[ `${formatMonthYear({ year, month })}`] = Number(orders);
            unitsObj[ `${formatMonthYear({ year, month })}`] = Number(units);

            gross_units_sellerObj[`${formatMonthYear({ year, month })}`] = Number(gross_units_seller ?? 0);
            gross_units_vendorObj[`${formatMonthYear({ year, month })}`] = Number(gross_units_vendor ?? 0);

            organic_unitsObj[ `${formatMonthYear({ year, month })}`] = Number(organic_units);
            acosObj[ `${formatMonthYear({ year, month })}`] = Number(acos);
            tacosObj[ `${formatMonthYear({ year, month })}`] = Number(tacos);
            roasObj[ `${formatMonthYear({ year, month })}`] = Number(roas);
            troasObj[ `${formatMonthYear({ year, month })}`] = Number(troas);
            ctrObj[ `${formatMonthYear({ year, month })}`] = Number(ctr);
            cvrObj[ `${formatMonthYear({ year, month })}`] = Number(cvr);
            cpcObj[ `${formatMonthYear({ year, month })}`] = Number(cpc);
            aovObj[ `${formatMonthYear({ year, month })}`] = Number(aov);
            cacObj[ `${formatMonthYear({ year, month })}`] = Number(cac);
            gross_glanceviewsObj[ `${formatMonthYear({ year, month })}`] = Number(gross_glanceviews);
          } else if (type === "all") {
            col.push({
              field: "all",
              headerName: "All",
              cellRenderer: AllCellRenderer,
              headerComponent: HeaderCellRenderer,
              width: 150,
            });
            tablewidth += 150;
            impressionsObj["all"] = Number(impressions);
            clicksObj["all"] = Number(clicks);
            costObj["all"] = Number(cost);
            salesObj["all"] = Number(sales);
            ad_sales_percObj["all"] = Number(ad_sales_perc);

            gross_sales_sellerObj["all"] = Number(gross_sales_seller ?? 0);
            gross_sales_vendorObj["all"] = Number(gross_sales_vendor ?? 0);

            organic_salesObj["all"] = Number(organic_sales);
            organic_sales_percObj["all"] = Number(organic_sales_perc);
            ordersObj["all"] = Number(orders);
            unitsObj["all"] = Number(units);

            gross_units_sellerObj["all"] = Number(gross_units_seller ?? 0);
            gross_units_vendorObj["all"] = Number(gross_units_vendor ?? 0);
            
            organic_unitsObj["all"] = Number(organic_units);
            acosObj["all"] = Number(acos);
            tacosObj["all"] = Number(tacos);
            roasObj["all"] = Number(roas);
            troasObj["all"] = Number(troas);
            ctrObj["all"] = Number(ctr);
            cvrObj["all"] = Number(cvr);
            cpcObj["all"] = Number(cpc);
            aovObj["all"] = Number(aov);
            cacObj["all"] = Number(cac);
            gross_glanceviewsObj["all"] = Number(gross_glanceviews);
          }
        }

        new_arr = [
          impressionsObj,
          clicksObj,
          costObj,
          salesObj,
          ad_sales_percObj,
          gross_sales_sellerObj,
          gross_sales_vendorObj,
          organic_salesObj,
          organic_sales_percObj,
          ordersObj,
          unitsObj,
          gross_units_sellerObj,
          gross_units_vendorObj,
          organic_unitsObj,
          acosObj,
          tacosObj,
          roasObj,
          troasObj,
          ctrObj,
          cvrObj,
          cpcObj,
          aovObj,
          cacObj,
          gross_glanceviewsObj,
        ];

        if (results?.length === 0) {
          setDataFetchingState("EMPTY");
        } else if (results?.length > 0) {
          setColumnDefs(col);
          setAgGridTableWidth(tablewidth + 8);
          setRawData(new_arr);
          setFetchData(new_arr);

          setDataFetchingState("SUCCESS");
        }

      } else if(transposeFormat === "HORIZONTAL"){
        let col: ColDef<DataProps>[] = [];

        // Start by adding the "Date" column
        col.push({
          field: "date",
          headerName: filter.type === "day" ? "Date" : filter.type === "week" ? "Week" : filter.type === "month" ? "Month" : "All",
          pinned: "left",
          cellRenderer: MatriceCellRenderer, // create if needed or use a default renderer
          headerComponent: MatriceNameHeaderCmp,
          width: 200,
        });
      
        // Define all metric column names
        const metricColumns = [
          "impressions", "clicks", "cost", "sales", "ad_sales_perc", "gross_sales_seller", "gross_sales_vendor",
          "organic_sales", "organic_sales_perc", "orders", "units", "gross_units_seller","gross_units_vendor",
          "organic_units", "acos", "tacos", "roas", "troas", "ctr", "cvr",
          "cpc", "aov", "cac", "gross_glanceviews"
        ];
      
        // Define a mapping from internal field names to user-friendly headers
        const metricNameMap: Record<string, string> = {
          impressions: "Impressions",
          clicks: "Clicks",
          cost: "Spend",
          sales: "Ad Sales",
          ad_sales_perc: "Ad Sales %",
          gross_sales_seller: "Gross Sales (Seller)",
          gross_sales_vendor: "Gross Sales (Vendor)",
          organic_sales: "Organic Sales",
          organic_sales_perc: "Organic Sales %",
          orders: "Ad Orders",
          units: "Ad Units",
          gross_units_seller: "Gross Units (Seller)",
          gross_units_vendor: "Gross Units (Vendor)",
          organic_units: "Organic Units",
          acos: "ACOS",
          tacos: "TACOS",
          roas: "ROAS",
          troas: "TROAS",
          ctr: "CTR",
          cvr: "CVR",
          cpc: "CPC",
          aov: "AOV",
          cac: "CAC",
          gross_glanceviews: "Glance View"
        };
      
        // Add metric columns to column definition
        for (const metric of metricColumns) {
          col.push({
            field: metric,
            headerName: metricNameMap[metric] || metric,
            cellRenderer: type === "day" ? DailyCellRenderer : type === "week" ? WeekCellRenderer : type === "month" ? MonthCellRenderer : AllCellRenderer, // use custom or default renderer
            headerComponent: HeaderCellRenderer,
            width: 150,
          });
          tablewidth += 150;
        }
      
        // Now map each result to a row object
        new_arr = results.map((el : any) => {
          let dateLabel = "";
      
          if (type === "day") {
            dateLabel = formatDatefunc({ date: el.date });
          } else if (type === "week") {
            const [year, month, , week] = el.date.split("-");
            dateLabel = formatWeekInput({ year, month, week });
          } else if (type === "month") {
            const [year, month] = el.date.split("-");
            dateLabel = formatMonthYear({ year, month });
          } else if (type === "all") {
            dateLabel = "All";
          }
      
          return {
            date: dateLabel,
            impressions: Number(el.impressions),
            clicks: Number(el.clicks),
            cost: Number(el.cost),
            sales: Number(el.sales),
            ad_sales_perc: Number(el.ad_sales_perc),
            gross_sales_seller: Number(el.gross_sales_seller ?? 0),
            gross_sales_vendor: Number(el.gross_sales_vendor ?? 0),
            organic_sales: Number(el.organic_sales),
            organic_sales_perc: Number(el.organic_sales_perc),
            orders: Number(el.orders),
            units: Number(el.units),
            gross_units_seller: Number(el.gross_units_seller ?? 0),
            gross_units_vendor: Number(el.gross_units_vendor ?? 0),
            organic_units: Number(el.organic_units),
            acos: Number(el.acos),
            tacos: Number(el.tacos),
            roas: Number(el.roas),
            troas: Number(el.troas),
            ctr: Number(el.ctr),
            cvr: Number(el.cvr),
            cpc: Number(el.cpc),
            aov: Number(el.aov),
            cac: Number(el.cac),
            gross_glanceviews: Number(el.gross_glanceviews),
          };
        });
      
        if (results?.length === 0) {
          setDataFetchingState("EMPTY");
        } else if (results?.length > 0) {
          setColumnDefs(col);
          setAgGridTableWidth(tablewidth + 8);
          setRawData(new_arr);
          setFetchData(new_arr);
          setDataFetchingState("SUCCESS");
        }
      }

    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  };

  const onSegmentFilterHandler = async () => {
    if (startDate > endDate) {
      setErrorToggle(true);
      return;
    }
    const { filter_type, type, year, month } = filter;
    let week =
      selweeks.length > 0
        ? selweeks
        : startDate && endDate
        ? [[Number(startDate), Number(endDate)]]
        : [];
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/getSummery?brand_id=${brand_id}`;
      const result = await axios.post(
        api,
        { filter_type, agg_type: type, year, month, week },
        { headers }
      );
      const { results, message } = result?.data?.data;
      let tablewidth = 200;
      let new_arr: any[] = [];
      if(transposeFormat === "VERTICAL"){
        let col: ColDef<DataProps>[] = [
          {
            field: "matrices",
            headerName: "Matrices",
            width: 200,
            cellRenderer: MatriceCellRenderer,
            headerComponent: MatriceNameHeaderCmp,
            pinned: 'left'
          },
        ];
        let impressionsObj: DynamicObject = {
          id: 1,
          matrices: "Impressions",
          backend_matrice_name: 'impressions'
        };
        let clicksObj: DynamicObject = {
          id: 2,
          matrices: "Clicks",
          backend_matrice_name: 'clicks'
        };
        let costObj: DynamicObject = {
          id: 3,
          matrices: "Spend",
          backend_matrice_name: 'cost'
        };
        let salesObj: DynamicObject = {
          id: 4,
          matrices: "Ad Sales",
          backend_matrice_name: 'sales'
        };
        let ad_sales_percObj: DynamicObject = {
          id: 5,
          matrices: "Ad Sales %",
          backend_matrice_name: 'ad_sales_perc'
        };
        let gross_sales_sellerObj: DynamicObject = {
          id: 6,
          matrices: "Gross Sales (Seller)",
          backend_matrice_name: 'gross_sales_seller'
        };
        let gross_sales_vendorObj: DynamicObject = {
          id: 7,
          matrices: "Gross Sales (Vendor)",
          backend_matrice_name: 'gross_sales_vendor'
        };
        let organic_salesObj: DynamicObject = {
          id: 8,
          matrices: "Organic Sales",
          backend_matrice_name: 'organic_sales'
        };
        let organic_sales_percObj: DynamicObject = {
          id: 9,
          matrices: "Organic Sales %",
          backend_matrice_name: 'organic_sales_perc'
        };
        let ordersObj: DynamicObject = {
          id: 10,
          matrices: "Ad Orders",
          backend_matrice_name: 'orders'
        };
        let unitsObj: DynamicObject = {
          id: 11,
          matrices: "Ad Units",
          backend_matrice_name: 'units'
        }; 
        let gross_units_sellerObj: DynamicObject = {
          id: 12,
          matrices: "Gross Units (Seller)",
          backend_matrice_name: 'gross_units_seller',
        };
        let gross_units_vendorObj: DynamicObject = {
          id: 13,
          matrices: "Gross Units (Vendor)",
          backend_matrice_name: 'gross_units_vendor',
        };
        let organic_unitsObj: DynamicObject = {
          id: 14,
          matrices: "Organic Units",
          backend_matrice_name: 'organic_units',
        };
        let acosObj: DynamicObject = {
          id: 15,
          matrices: "ACOS",
          backend_matrice_name: 'acos',
        };
        let tacosObj: DynamicObject = {
          id: 16,
          matrices: "TACOS",
          backend_matrice_name: 'tacos',
        };
        let roasObj: DynamicObject = {
          id: 17,
          matrices: "ROAS",
          backend_matrice_name: 'roas',
        };
        let troasObj: DynamicObject = {
          id: 18,
          matrices: "TROAS",
          backend_matrice_name: 'troas',
        };
        let ctrObj: DynamicObject = {
          id: 19,
          matrices: "CTR",
          backend_matrice_name: 'ctr',
        };
        let cvrObj: DynamicObject = {
          id: 20,
          matrices: "CVR",
          backend_matrice_name: 'cvr',
        };
        let cpcObj: DynamicObject = {
          id: 21,
          matrices: "CPC",
          backend_matrice_name: 'cpc',
        };
        let aovObj: DynamicObject = {
          id: 22,
          matrices: "AOV",
          backend_matrice_name: 'aov',
        };
        let cacObj: DynamicObject = {
          id: 23,
          matrices: "CAC",
          backend_matrice_name: 'cac',
        };
        let gross_glanceviewsObj: DynamicObject = {
          id: 24,
          matrices: "Glance View",
          backend_matrice_name: 'gross_glanceviews',
        };

        for (let el of results) {
          let {
            date,
            impressions,
            clicks,
            cost,
            sales,
            units,
            ad_sales_perc,
            gross_sales_seller,
            gross_sales_vendor,
            organic_sales,
            organic_sales_perc,
            orders,
            gross_units_seller,
            gross_units_vendor,
            organic_units,
            acos,
            tacos,
            roas,
            troas,
            ctr,
            cvr,
            cpc,
            aov,
            cac,
            gross_glanceviews,
          } = el;
          if (type === "day") {
            col.push({
              field: date,
              headerName: `${formatDatefunc({ date })}`,
              cellRenderer: DailyCellRenderer,
              headerComponent: HeaderCellRenderer,
              width: 150,
            });
            tablewidth += 150;
            impressionsObj[date] = Number(impressions);
            clicksObj[date] = Number(clicks);
            costObj[date] = Number(cost);
            salesObj[date] = Number(sales);
            ad_sales_percObj[date] = Number(ad_sales_perc);
            gross_sales_sellerObj[date] = Number(gross_sales_seller ?? 0);
            gross_sales_vendorObj[date] = Number(gross_sales_vendor ?? 0);
            organic_salesObj[date] = Number(organic_sales);
            organic_sales_percObj[date] = Number(organic_sales_perc);
            ordersObj[date] = Number(orders);
            unitsObj[date] = Number(units);
            gross_units_sellerObj[date] = Number(gross_units_seller ?? 0);
            gross_units_vendorObj[date] = Number(gross_units_vendor ?? 0);
            organic_unitsObj[date] = Number(organic_units);
            acosObj[date] = Number(acos);
            tacosObj[date] = Number(tacos);
            roasObj[date] = Number(roas);
            troasObj[date] = Number(troas);
            ctrObj[date] = Number(ctr);
            cvrObj[date] = Number(cvr);
            cpcObj[date] = Number(cpc);
            aovObj[date] = Number(aov);
            cacObj[date] = Number(cac);
            gross_glanceviewsObj[date] = Number(gross_glanceviews);
          } else if (type === "week") {
            const [year, month, week_name, week] = date?.split("-");
            col.push({
              field: `${formatWeekInputForCsv({ year, month, week })}`,
              headerName: `${formatWeekInput({ year, month, week })}`,
              cellRenderer: WeekCellRenderer,
              headerComponent: HeaderCellRenderer,
              width: 150,
            });
            tablewidth += 150;
            impressionsObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(impressions);
            clicksObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(clicks);
            costObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(cost);
            salesObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(sales);
            ad_sales_percObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(ad_sales_perc);
            gross_sales_sellerObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_sales_seller ?? 0);
            gross_sales_vendorObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_sales_vendor ?? 0);
            organic_salesObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(organic_sales);
            organic_sales_percObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(organic_sales_perc);
            ordersObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(orders);
            unitsObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(units);
            gross_units_sellerObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_units_seller ?? 0);
            gross_units_vendorObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_units_vendor ?? 0);
            organic_unitsObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(organic_units);
            acosObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(acos);
            tacosObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(tacos);
            roasObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(roas);
            troasObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(troas);
            ctrObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(ctr);
            cvrObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(cvr);
            cpcObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(cpc);
            aovObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(aov);
            cacObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(cac);
            gross_glanceviewsObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_glanceviews);
          } else if (type === "month") {
            const [year, month, week_name, week] = date?.split("-");
            col.push({
              field:  `${formatMonthYear({ year, month })}`,
              headerName: `${formatMonthYear({ year, month })}`,
              cellRenderer: MonthCellRenderer,
              headerComponent: HeaderCellRenderer,
              width: 150,
            });
            tablewidth += 150;
            impressionsObj[ `${formatMonthYear({ year, month })}`] = Number(impressions);
            clicksObj[ `${formatMonthYear({ year, month })}`] = Number(clicks);
            costObj[ `${formatMonthYear({ year, month })}`] = Number(cost);
            salesObj[ `${formatMonthYear({ year, month })}`] = Number(sales);
            ad_sales_percObj[ `${formatMonthYear({ year, month })}`] = Number(ad_sales_perc);
            gross_sales_sellerObj[`${formatMonthYear({ year, month })}`] = Number(gross_sales_seller ?? 0);
            gross_sales_vendorObj[`${formatMonthYear({ year, month })}`] = Number(gross_sales_vendor ?? 0);
            organic_salesObj[ `${formatMonthYear({ year, month })}`] = Number(organic_sales);
            organic_sales_percObj[ `${formatMonthYear({ year, month })}`] = Number(organic_sales_perc);
            ordersObj[ `${formatMonthYear({ year, month })}`] = Number(orders);
            unitsObj[ `${formatMonthYear({ year, month })}`] = Number(units);
            gross_units_sellerObj[`${formatMonthYear({ year, month })}`] = Number(gross_units_seller ?? 0);
            gross_units_vendorObj[`${formatMonthYear({ year, month })}`] = Number(gross_units_vendor ?? 0);
            organic_unitsObj[ `${formatMonthYear({ year, month })}`] = Number(organic_units);
            acosObj[ `${formatMonthYear({ year, month })}`] = Number(acos);
            tacosObj[ `${formatMonthYear({ year, month })}`] = Number(tacos);
            roasObj[ `${formatMonthYear({ year, month })}`] = Number(roas);
            troasObj[ `${formatMonthYear({ year, month })}`] = Number(troas);
            ctrObj[ `${formatMonthYear({ year, month })}`] = Number(ctr);
            cvrObj[ `${formatMonthYear({ year, month })}`] = Number(cvr);
            cpcObj[ `${formatMonthYear({ year, month })}`] = Number(cpc);
            aovObj[ `${formatMonthYear({ year, month })}`] = Number(aov);
            cacObj[ `${formatMonthYear({ year, month })}`] = Number(cac);
            gross_glanceviewsObj[ `${formatMonthYear({ year, month })}`] = Number(gross_glanceviews);
          } else if (type === "all") {
            col.push({
              field: "all",
              headerName: "All",
              cellRenderer: AllCellRenderer,
              headerComponent: HeaderCellRenderer,
              width: 150,
            });
            tablewidth += 150;
            impressionsObj["all"] = Number(impressions);
            clicksObj["all"] = Number(clicks);
            costObj["all"] = Number(cost);
            salesObj["all"] = Number(sales);
            ad_sales_percObj["all"] = Number(ad_sales_perc);
            gross_sales_sellerObj["all"] = Number(gross_sales_seller ?? 0);
            gross_sales_vendorObj["all"] = Number(gross_sales_vendor ?? 0);
            organic_salesObj["all"] = Number(organic_sales);
            organic_sales_percObj["all"] = Number(organic_sales_perc);
            ordersObj["all"] = Number(orders);
            unitsObj["all"] = Number(units);
            gross_units_sellerObj["all"] = Number(gross_units_seller ?? 0);
            gross_units_vendorObj["all"] = Number(gross_units_vendor ?? 0);
            organic_unitsObj["all"] = Number(organic_units);
            acosObj["all"] = Number(acos);
            tacosObj["all"] = Number(tacos);
            roasObj["all"] = Number(roas);
            troasObj["all"] = Number(troas);
            ctrObj["all"] = Number(ctr);
            cvrObj["all"] = Number(cvr);
            cpcObj["all"] = Number(cpc);
            aovObj["all"] = Number(aov);
            cacObj["all"] = Number(cac);
            gross_glanceviewsObj["all"] = Number(gross_glanceviews);
          }
        }
        setColumnDefs(col);

        new_arr = [
          impressionsObj,
          clicksObj,
          costObj,
          salesObj,
          ad_sales_percObj,
          gross_sales_sellerObj,
          gross_sales_vendorObj,
          organic_salesObj,
          organic_sales_percObj,
          ordersObj,
          unitsObj,
          gross_units_sellerObj,
          gross_units_vendorObj,
          organic_unitsObj,
          acosObj,
          tacosObj,
          roasObj,
          troasObj,
          ctrObj,
          cvrObj,
          cpcObj,
          aovObj,
          cacObj,
          gross_glanceviewsObj,
        ];

        if (results?.length === 0) {
          setDataFetchingState("EMPTY");
        } else if (results?.length > 0) {
          setAgGridTableWidth(tablewidth + 8);
          setRawData(new_arr);
          setFetchData(new_arr);
          setDataFetchingState("SUCCESS");
        }

      } else if(transposeFormat === "HORIZONTAL"){
          let col: ColDef<DataProps>[] = [
            {
              field: "date",
              headerName:
                type === "day"
                  ? "Date"
                  : type === "week"
                  ? "Week"
                  : type === "month"
                  ? "Month"
                  : "All",
              width: 200,
              pinned: "left",
              cellRenderer:
                type === "day"
                  ? DailyCellRenderer
                  : type === "week"
                  ? WeekCellRenderer
                  : type === "month"
                  ? MonthCellRenderer
                  : AllCellRenderer,
              headerComponent: HeaderCellRenderer,
            },
            {
              field: "impressions",
              headerName: "Impressions",
              width: 150,
            },
            {
              field: "clicks",
              headerName: "Clicks",
              width: 150,
            },
            {
              field: "cost",
              headerName: "Spend",
              width: 150,
            },
            {
              field: "sales",
              headerName: "Ad Sales",
              width: 150,
            },
            {
              field: "ad_sales_perc",
              headerName: "Ad Sales %",
              width: 150,
            },
            {
              field: "gross_sales_seller",
              headerName: "Gross Sales (Seller)",
              width: 150,
            },
            {
              field: "gross_sales_vendor",
              headerName: "Gross Sales (Vendor)",
              width: 150,
            },
            {
              field: "organic_sales",
              headerName: "Organic Sales",
              width: 150,
            },
            {
              field: "organic_sales_perc",
              headerName: "Organic Sales %",
              width: 150,
            },
            {
              field: "orders",
              headerName: "Ad Orders",
              width: 150,
            },
            {
              field: "units",
              headerName: "Ad Units",
              width: 150,
            },
            {
              field: "gross_units_seller",
              headerName: "Gross Units (Seller)",
              width: 150,
            },
            {
              field: "gross_units_vendor",
              headerName: "Gross Units (Vendor)",
              width: 150, 
            },
            {
              field: "organic_units",
              headerName: "Organic Units",
              width: 150,
            },
            {
              field: "acos",
              headerName: "ACOS",
              width: 150,
            },
            {
              field: "tacos",
              headerName: "TACOS",
              width: 150,
            },
            {
              field: "roas",
              headerName: "ROAS",
              width: 150,
            },
            {
              field: "troas",
              headerName: "TROAS",
              width: 150,
            },
            {
              field: "ctr",
              headerName: "CTR",
              width: 150,
            },
            {
              field: "cvr",
              headerName: "CVR",
              width: 150,
            },
            {
              field: "cpc",
              headerName: "CPC",
              width: 150,
            },
            {
              field: "aov",
              headerName: "AOV",
              width: 150,
            },
            {
              field: "cac",
              headerName: "CAC",
              width: 150,
            },
            {
              field: "gross_glanceviews",
              headerName: "Glance View",
              width: 150,
            },
          ];
        
          setColumnDefs(col);
          tablewidth = col.length * 150;
        
          let horizontalData: DynamicObject[] = [];
        
          for (let el of results) {
            const {
              date,
              impressions,
              clicks,
              cost,
              sales,
              ad_sales_perc,
              gross_sales_seller,
              gross_sales_vendor,
              organic_sales,
              organic_sales_perc,
              orders,
              units,
              gross_units_seller,
              gross_units_vendor,
              organic_units,
              acos,
              tacos,
              roas,
              troas,
              ctr,
              cvr,
              cpc,
              aov,
              cac,
              gross_glanceviews,
            } = el;
        
            let formattedDate = "";
        
            if (type === "day") {
              formattedDate = formatDatefunc({ date });
            } else if (type === "week") {
              const [year, month, week_name, week] = date?.split("-");
              formattedDate = formatWeekInput({ year, month, week });
            } else if (type === "month") {
              const [year, month, week_name, week] = date?.split("-");
              formattedDate = formatMonthYear({ year, month });
            } else if (type === "all") {
              formattedDate = "All";
            }
        
            horizontalData.push({
              date: formattedDate,
              impressions: Number(impressions),
              clicks: Number(clicks),
              cost: Number(cost),
              sales: Number(sales),
              ad_sales_perc: Number(ad_sales_perc),
              gross_sales_seller: Number(gross_sales_seller ?? 0),
              gross_sales_vendor: Number(gross_sales_vendor ?? 0),
              organic_sales: Number(organic_sales),
              organic_sales_perc: Number(organic_sales_perc),
              orders: Number(orders),
              units: Number(units),
              gross_units_seller: Number(gross_units_seller ?? 0),
              gross_units_vendor: Number(gross_units_vendor ?? 0),
              organic_units: Number(organic_units),
              acos: Number(acos),
              tacos: Number(tacos),
              roas: Number(roas),
              troas: Number(troas),
              ctr: Number(ctr),
              cvr: Number(cvr),
              cpc: Number(cpc),
              aov: Number(aov),
              cac: Number(cac),
              gross_glanceviews: Number(gross_glanceviews),
            });
          }
        
          if (results?.length === 0) {
            setDataFetchingState("EMPTY");
          } else {
            setAgGridTableWidth(tablewidth + 8);
            setRawData(horizontalData);
            setFetchData(horizontalData);
            setDataFetchingState("SUCCESS");
          }
        // if (new_arr?.length === 0) {
        //   setDataFetchingState("EMPTY");
        // } else if (new_arr?.length > 0) {
        //   setAgGridTableWidth(tablewidth + 8);
        //   setRawData(new_arr);
        //   setFetchData(new_arr);
        //   setDataFetchingState("SUCCESS");
        // }
      }

      
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  };

  const [draggedItem, setDraggedItem] = useState<Matrice | null>(null);
  const handleDragStart = (item: Matrice) => {
    setDraggedItem(item);
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const handleDrop = (ag_targetItem: Matrice, ag_matricesDataDrawer: Matrice[]) => {
    if (!draggedItem || draggedItem.id === ag_targetItem.id) return;
  
    const draggedIndex = ag_matricesDataDrawer.findIndex(
      (item) => item?.id === draggedItem.id
    );
    const targetIndex = ag_matricesDataDrawer.findIndex(
      (item) => item?.id === ag_targetItem.id
    );
  
    if (draggedIndex === -1 || targetIndex === -1) return;
  
    // Clone the array to avoid mutating state directly
    const updatedMatricesData = [...ag_matricesDataDrawer];
  
    // Remove the dragged item
    const [draggedMatrice] = updatedMatricesData.splice(draggedIndex, 1);
  
    // Insert it at the target index
    updatedMatricesData.splice(targetIndex, 0, draggedMatrice);
  
    // Reassign position field based on new order
    const reorderedMatricesData = updatedMatricesData.map((item, index) => ({
      ...item,
      position: index,
    }));
  
    return reorderedMatricesData;
    // setMatricesDataDrawer(reorderedMatricesData);
    // updateColumns("METRICE", reorderedMatricesData); // Uncomment if needed
  };

  // PUT API for Column
  const updateColumns = async (
    column_name: string,
    ipNewMatricesArr: Matrice[]
  ) => {
    try {
      const token = localStorage.getItem("token");
      interface TempObj {
        dashboard: string;
        column_type: string;
        column_array?: any[]; // Optional property, replace `any[]` with a specific type if known
      }
      let temp_obj: TempObj = {
        dashboard: "ADS_OVERVIEW_ANALYSIS",
        column_type: column_name,
      };
      if (column_name === "METRICE") {
        temp_obj.column_array = ipNewMatricesArr;
      }
      const res = await axios.put(
        `${BASE_URL}settings/columnSettings?brand_id=${brand_id}&platform_id=${platform_id}`,
        temp_obj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      appError(error);
    }
  };

  const handleSwitchChange = (ag_matrice_id: Number, ag_matricesDataDrawer: Matrice[]) => {
    const Exist = ag_matricesDataDrawer.find(
      (d: Matrice) => d?.id === ag_matrice_id
    )?.toggle;
    let newMatricesArr = [] as Matrice[];
    if (Exist) {
      if (ag_matricesDataDrawer.filter((item) => item.toggle).length === 1) {
        toast.error("Minimum 1 Matrice to be present");
        return;
      } else if (ag_matricesDataDrawer.filter((item) => item.toggle).length > 1) {
        newMatricesArr = ag_matricesDataDrawer.map((d) =>
          d.id === ag_matrice_id ? { ...d, toggle: false } : d
        );
      }
    } else {
      newMatricesArr = ag_matricesDataDrawer.map((d) =>
        d.id === ag_matrice_id ? { ...d, toggle: true } : d
      );
    }

    return newMatricesArr;
  };

  useEffect(() => {
    if (
      filter?.filter_type === "TIMELINE" &&
      filter?.start_date &&
      filter?.end_date &&
      brand_id
    ) {
      onTimelineFilterHandler();
    } else if (
      filter?.filter_type === "SEGMENT" &&
      (filter?.month.length > 0 &&
        filter?.year.length > 0 &&
        filter?.week.length > 0) &&
      brand_id
    ) {
      onSegmentFilterHandler();
    }
  }, [filter, transposeFormat]);

  useEffect(() => {
    if (
      filter?.filter_type === "TIMELINE" &&
      filter?.start_date &&
      filter?.end_date &&
      brand_id
    ) {
      onChangeStageHandler(view, performer, product_detail, metricsData2);
    } else if (
      filter?.filter_type === "SEGMENT" &&
      (filter?.month.length > 0 &&
        filter?.year.length > 0 &&
        filter?.week.length > 0) &&
      brand_id
    ) {
      onChangeStageHandler(view, performer, product_detail, metricsData2);
    }
  }, [
    filter?.start_date,
    filter?.end_date,
    filter?.filter_type,
    filter?.month,
    filter?.week, 
    filter?.year
  ]);


  const getBrandDetails = () => {
    const storedBrandRange = localStorage.getItem("BrandRange");
    if (storedBrandRange) {
      try {
        const parsedRange = JSON.parse(storedBrandRange);
        setRange({
          min_date: new Date(parsedRange?.min_date.split("T")[0]),
          max_date: new Date(parsedRange?.max_date.split("T")[0]),
        });
        let weekRange = getWeekRange(new Date());
        if (
          weekRange &&
          weekRange?.currentWeekStart >
            new Date(parsedRange?.max_date.split("T")[0])
        ) {
          weekRange = getWeekRange(
            new Date(parsedRange?.max_date.split("T")[0])
          );
        }

        let new_filter = {
          ...filter,
          filter_type: "TIMELINE",
          start_date: weekRange?.currentWeekStart || new Date(),
          end_date: new Date(parsedRange?.max_date.split("T")[0]),
        };
        setFilter((prev) => {
          // let weekRange = getWeekRange(new Date());
          // if (
          //   weekRange &&
          //   weekRange?.currentWeekStart >
          //     new Date(parsedRange?.max_date.split("T")[0])
          // ) {
          //   weekRange = getWeekRange(
          //     new Date(parsedRange?.max_date.split("T")[0])
          //   );
          // }
          return new_filter;
        });
        setYears([
          { id: "Select All", label: "Select All" },
          ...getYearsFromGivenRange(
            new Date(parsedRange?.min_date.split("T")[0]),
            new Date(parsedRange?.max_date.split("T")[0])
          ),
        ]);
        setMonths([
          { id: "13", label: "Select All" },
          ...getMonthsInRange(
            new Date(parsedRange?.min_date.split("T")[0]),
            new Date(parsedRange?.max_date.split("T")[0])
          ),
        ]);
        const savedState = localStorage.getItem('overview_summary_section2TableData');

        if (savedState) {
          const parsedState = JSON.parse(savedState);
          setView(parsedState?.ag_view);
          setPerformer(parsedState?.ag_performer); // array
          setProduct_detail(parsedState?.ag_productDetail);
          setMetricsData2(parsedState?.ag_metrics);
          setMatricesDataDrawer2(parsedState?.ag_metrics);
          fetchSection2Data(parsedState?.ag_view, parsedState?.ag_performer, parsedState?.ag_productDetail, new_filter, parsedState?.ag_metrics);
        }
        else {
          fetchSection2Data(view, performer, product_detail, filter, metricsData2);
        }
      } catch (error) {
        appError("Error parsing BrandRange & Brand from localStorage:", error);
      }
    }
  };

  // GET API For Column
  const fetchColumnData = async (column_name: string) => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}settings/columnSettings?brand_id=${brand_id}&platform_id=${platform_id}&dashboard=ADS_OVERVIEW_ANALYSIS&column_type=${column_name}`;
      const result = await axios.get(api, { headers });
      const { column_array } = result.data.data;
      if (column_name === "METRICE") {
        if (column_array.length !== 0) {
          setMatricesData(column_array);
          setMatricesDataDrawer(column_array);
          let positionchangedfilter =  column_array?.filter((item: DataProps, index: number) => item.id !== (index + 1));
          if(positionchangedfilter?.length > 0){
            setResetToggle(true);
          }
        } else {
          let new_metrics_arr = [
            {
              id: 1,
              matrice_name: "Impressions",
              backend_matrice_name: "impressions",
              toggle: true,
              position: 0,
            },
            {
              id: 2,
              matrice_name: "Clicks",
              backend_matrice_name: "clicks",
              toggle: true,
              position: 1,
            },
            {
              id: 3,
              matrice_name: "Spend",
              backend_matrice_name: "cost",
              toggle: true,
              position: 2,
            },
            {
              id: 4,
              matrice_name: "Ad Sales",
              backend_matrice_name: "sales",
              toggle: true,
              position: 3,
            },
            {
              id: 5,
              matrice_name: "Ad Sales %",
              backend_matrice_name: "ad_sales_perc",
              toggle: true,
              position: 4,
            },
            {
              id: 6,
              matrice_name: "Gross Sales (Seller)",
              backend_matrice_name: "gross_sales_seller",
              toggle: true,
              position: 5,
            },
            {
              id: 7,
              matrice_name: "Gross Sales (Vendor)",
              backend_matrice_name: "gross_sales_vendor",
              toggle: true,
              position: 6,
            },
            {
              id: 8,
              matrice_name: "Organic Sales",
              backend_matrice_name: "organic_sales",
              toggle: true,
              position: 7,
            },
            {
              id: 9,
              matrice_name: "Organic Sales %",
              backend_matrice_name: "organic_sales_perc",
              toggle: true,
              position: 8,
            },
            {
              id: 10,
              matrice_name: "Ad Orders",
              backend_matrice_name: "orders",
              toggle: true,
              position: 9,
            },
            {
              id: 11,
              matrice_name: "Ad Units",
              backend_matrice_name: "units",
              toggle: true,
              position: 10,
            },
            {
              id: 12,
              matrice_name: "Gross Units (Seller)",
              backend_matrice_name: "gross_units_seller",
              toggle: true,
              position: 11,
            },
            {
              id: 13,
              matrice_name: "Gross Units (Vendor)",
              backend_matrice_name: "gross_units_vendor",
              toggle: true,
              position: 12,
            },
            {
              id: 14,
              matrice_name: "Organic Units",
              backend_matrice_name: "organic_units",
              toggle: true,
              position: 13,
            },
            {
              id: 15,
              matrice_name: "ACOS",
              backend_matrice_name: "acos",
              toggle: true,
              position: 14,
            },
            {
              id: 16,
              matrice_name: "TACOS",
              backend_matrice_name: "tacos",
              toggle: true,
              position: 15,
            },
            {
              id: 17,
              matrice_name: "ROAS",
              backend_matrice_name: "roas",
              toggle: true,
              position: 16,
            },
            {
              id: 18,
              matrice_name: "TROAS",
              backend_matrice_name: "troas",
              toggle: true,
              position: 17,
            },
            {
              id: 19,
              matrice_name: "CTR",
              backend_matrice_name: "ctr",
              toggle: true,
              position: 18,
            },
            {
              id: 20,
              matrice_name: "CVR",
              backend_matrice_name: "cvr",
              toggle: true,
              position: 19,
            },
            {
              id: 21,
              matrice_name: "CPC",
              backend_matrice_name: "cpc",
              toggle: true,
              position: 20,
            },
            {
              id: 22,
              matrice_name: "AOV",
              backend_matrice_name: "aov",
              toggle: true,
              position: 21,
            },
            {
              id: 23,
              matrice_name: "CAC",
              backend_matrice_name: "cac",
              toggle: true,
              position: 22,
            },
            {
              id: 24,
              matrice_name: "Glance View",
              backend_matrice_name: "gross_glanceviews",
              toggle: true,
              position: 23,
            },
          ];          
          setMatricesData(new_metrics_arr);
          setMatricesDataDrawer(new_metrics_arr);
        }
      }
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  };

  let exportRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  let exportButtonRef = useRef<HTMLButtonElement | null>(null); // Menu button reference

  let dateRangeCmpRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  let dateRangeCmpButtonRef = useRef<HTMLImageElement | null>(null); // Menu button reference
  
  const exporthandleClickOutside = (event: MouseEvent) => {
    // Check if the click is outside the dropdown (menuRef)
    if (
      exportRef.current &&
      !exportRef.current.contains(event.target as Node) &&
      exportButtonRef.current &&
      !exportButtonRef.current.contains(event.target as Node)
    ) {
      setExportToggle(false); // Close the dropdown if clicked outside
    }
  };

  const dateRangehandleClickOutside = (event: MouseEvent) => {
    // Check if the click is outside the dropdown (menuRef)
    if (
      dateRangeCmpRef.current &&
      !dateRangeCmpRef.current.contains(event.target as Node) &&
      dateRangeCmpButtonRef.current &&
      !dateRangeCmpButtonRef.current.contains(event.target as Node)
    ) {
      setDateToggle(false); // Close the dropdown if clicked outside
    }
  };

  // Add event listener to detect clicks outside
  useEffect(() => {
    document.addEventListener("click", exporthandleClickOutside);
    document.addEventListener("click", dateRangehandleClickOutside);
    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", exporthandleClickOutside);
      document.removeEventListener("click", dateRangehandleClickOutside);
    };
  }, []);

  // const saveSection2TableData = () => {
  //   const savedState = localStorage.getItem('overview_summary_section2TableData');

  //   if (savedState) {
  //     const parsedState = JSON.parse(savedState);
  //     setView(parsedState?.ag_view);
  //     setPerformer(parsedState?.ag_performer); // array
  //     setProduct_detail(parsedState?.ag_productDetail);
  //     setMetricsData2(parsedState?.ag_metrics);
  //     setMatricesDataDrawer2(parsedState?.ag_metrics);
  //   }
  // }

  useEffect(() => {
    if (brand_id && platform_id) {
      getBrandDetails();
      // saveSection2TableData();
      fetchColumnData("METRICE");
    }
  }, [brand_id, platform_id]);

  useEffect(() => { 
    if(transposeFormat === "VERTICAL"){
      if (fetchData.length > 0 && matricesData.length > 0) {
        const positionMap = new Map(
          matricesData
            .filter((matrice) => matrice.toggle) // Include only toggled items
            .map((matrice) => [matrice.id, matrice.position]) // Map id to position
        );

        // Filter and sort fetchData based on matricesData
        const sortedAndFilteredData = fetchData
          .filter((item) => positionMap.has(item.id)) // Keep only items in matricesData
          .sort(
            (a, b) => (positionMap.get(a.id) ?? 0) - (positionMap.get(b.id) ?? 0)
          ); // Sort by position
        setfilterData(sortedAndFilteredData);
      }
    }
    else {
      if (fetchData.length > 0 && matricesData.length > 0) {

          const filteredMatrices = matricesData?.filter(m => m.toggle) // or use a.position - b.position if you prefer hierarchy based on `position`

          const backendKeys = filteredMatrices.map(m => m?.backend_matrice_name);

          const transformedData = fetchData.map(entry => {
            const filteredEntry: any = {
              date: entry.date, // Keep the date
            };

            for (const key of backendKeys) {
              filteredEntry[key] = entry[key];
            }

            return filteredEntry;
          });

          setfilterData(transformedData);

              // Base column for date (pinned left)
          const baseColumns: ColDef[] = [
            {
              field: 'date',
              headerName: filter.type === "day" ? "Date" : filter.type === "week" ? "Week" : filter.type === "month" ? "Month" : "All",
              pinned: 'left',
              cellRenderer: MatriceCellRenderer, // Replace with real renderer
              headerComponent: MatriceNameHeaderCmp, // Replace with real header
            },
          ]; 

          // Dynamic columns from filtered matrices
          const dynamicColumns: ColDef[] = filteredMatrices.map(m => ({
            field: m.backend_matrice_name,
            headerName: m.matrice_name,
            width: 150,
            cellRenderer: filter.type === "day" ? DailyCellRenderer : filter.type === "week" ? WeekCellRenderer : filter.type === "month" ? MonthCellRenderer : AllCellRenderer, // Replace with real renderer
            headerComponent: HeaderCellRenderer, // Replace with real header
          }));

          // Save column definitions and filtered data to state
          setColumnDefs([...baseColumns, ...dynamicColumns]);

      }
    }
  }, [fetchData, matricesData]);

  const columnsApply = (ag_sectionType: string) => {
    if(ag_sectionType === "FIRST" && matricesDataDrawer?.length > 0){
      setMatricesData([...matricesDataDrawer]);
      updateColumns("METRICE", matricesDataDrawer);

      let positionchangedfilter =  matricesDataDrawer?.filter((item: Matrice, index: number) => item.id !== (index + 1));
      if(positionchangedfilter?.length > 0){
        setResetToggle(true);
      } else {
        setResetToggle(false);
      }
      setRowsToggle(false);
    }

    if(ag_sectionType === "SECOND" && matricesDataDrawer2?.length > 0){
      setMetricsData2([...matricesDataDrawer2]);
      // updateColumns("METRICE", matricesDataDrawer2);
      onChangeStageHandler(view, performer, product_detail, matricesDataDrawer2);
      saveLastStateInLocalStorage(view, performer, product_detail, matricesDataDrawer2);

      let positionchangedfilter =  matricesDataDrawer2?.filter((item: Matrice, index: number) => item.id !== (index + 1));
      if(positionchangedfilter?.length > 0){
        setResetToggle2(true);
      } else {
        setResetToggle2(false);
      }
      setMetricsToggle(false);
    }
  }

  const onResetColumnsHandler = (ag_section_type: string) => {
    if(ag_section_type === 'FIRST'){
    setMatricesDataDrawer((prev) => {
      const sortedMatrices = [...prev].sort((a, b) => a.id - b.id);
      
      // Update the position field in numerical order
      const updatedMatrices = sortedMatrices.map((item, index) => ({
        ...item,
        position: index, // Assign position based on the index in the sorted array
      }));
      
      return updatedMatrices;
    }); 

  } else if(ag_section_type === 'SECOND'){
    setMatricesDataDrawer2((prev) => {
      const sortedMatrices = [...prev].sort((a, b) => a.id - b.id);
      
      // Update the position field in numerical order
      const updatedMatrices = sortedMatrices.map((item, index) => ({
        ...item,
        position: index, // Assign position based on the index in the sorted array
      }));
      
      return updatedMatrices;
    }); 
  }
  }
  const [exportToggle, setExportToggle] = useState<boolean>(false);
  const [customExportToggle, setCustomExportToggle] = useState<boolean>(false);
  const [exportLoading, setExportLoading] =  useState<boolean>(false);

  const exportSelectionHandler = () => {  //Done
    if(filter?.filter_type === 'SEGMENT' && 
      filter?.year.length > 0 &&
      filter?.month.length > 0 &&
      filter?.week.length > 0){
      if(transposeFormat === "VERTICAL"){   
        const cleanedData = filterdata?.map(((item: DataProps) => {
          const new_obj: DataProps = {};
          for(let key in item){
            if(key !== 'id' && key !== 'backend_matrice_name' && key !== 'all' && key !== 'matrices'){
              new_obj[key] = item[key];
            }
            if(key === 'all'){
              new_obj['All'] = item[key];
            }
            if(key === 'matrices'){
              new_obj['Matrices'] = item[key];
            }
          }
          return new_obj;
        }));
        downloadCSV(cleanedData, "OverviewSummaryData.csv");   

      }else if(transposeFormat === "HORIZONTAL"){
        const cleanedData = filterdata?.map((item: DataProps) => {
          const new_obj: DataProps = {};
          for(let key in item) {
            if(key === 'date'){
              if(filter?.type === 'day'){
                new_obj['Dates'] = item[key];
              } else if(filter?.type === 'week'){
                new_obj['Weeks'] = item[key];
              } else if(filter?.type === 'month'){
                new_obj['Months'] = item[key];
              } else if(filter?.type === 'all'){
                new_obj['All'] = item[key];
              }
            }
            else {
              const matriceObj = matricesData?.find(item => item?.backend_matrice_name === key);
              if(matriceObj){
                new_obj[matriceObj?.matrice_name] = item[key];
              }
            }
          }

          return new_obj;
        });
        downloadCSV(cleanedData, "OverviewSummaryData.csv");  

      }

    } else if(filter?.filter_type === 'TIMELINE'){
      if(transposeFormat === "VERTICAL"){   
        const cleanedData = filterdata?.map(((item: DataProps) => {
          const new_obj: DataProps = {};
          for(let key in item){
            if(key !== 'id' && key !== 'backend_matrice_name' && key !== 'all' && key !== 'matrices'){
              new_obj[key] = item[key];
            }
            if(key === 'all'){
              new_obj['All'] = item[key];
            }
            if(key === 'matrices'){
              new_obj['Matrices'] = item[key];
            }
          }
          return new_obj;
        }));
        downloadCSV(cleanedData, "OverviewSummaryData.csv");  

      }else if(transposeFormat === "HORIZONTAL"){
        const cleanedData = filterdata?.map((item: DataProps) => {
          const new_obj: DataProps = {};
          for(let key in item) {
            if(key === 'date'){
              if(filter?.type === 'day'){
                new_obj['Dates'] = item[key];
              } else if(filter?.type === 'week'){
                new_obj['Weeks'] = item[key];
              } else if(filter?.type === 'month'){
                new_obj['Months'] = item[key];
              } else if(filter?.type === 'all'){
                new_obj['All'] = item[key];
              }
            }
            else {
              const matriceObj = matricesData?.find(item => item?.backend_matrice_name === key);
              if(matriceObj){
                new_obj[matriceObj?.matrice_name] = item[key];
              }
            }
          }

          return new_obj;
        });
        downloadCSV(cleanedData, "OverviewSummaryData.csv");  

      }
    }

    setExportToggle(false);
  }

  const onTimelineCustomExportHandler = async (ip_filter: FilterProps, ip_matrices: Matrice[], ip_transposeFormat: string,) => {
    const token = localStorage.getItem("token");
    
    const { filter_type, type, start_date, end_date } = ip_filter;
    try {
      setExportLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/getSummery?brand_id=${brand_id}`;
      const result = await axios.post(
        api,
        {
          agg_type: type,
          filter_type,
          start_date: formatDate(start_date),
          end_date: formatDate(end_date),
        },
        { headers }
      );
      const { results, message } = result?.data?.data;
      let new_arr: any[] = [];
      if(ip_transposeFormat === "VERTICAL"){
        let impressionsObj: DynamicObject = {
          id: 1,
          matrices: "Impressions",
          backend_matrice_name: 'impressions'
        };
        let clicksObj: DynamicObject = {
          id: 2,
          matrices: "Clicks",
          backend_matrice_name: 'clicks'
        };
        let costObj: DynamicObject = {
          id: 3,
          matrices: "Spend",
          backend_matrice_name: 'cost'
        };
        let salesObj: DynamicObject = {
          id: 4,
          matrices: "Ad Sales",
          backend_matrice_name: 'sales'
        };
        let ad_sales_percObj: DynamicObject = {
          id: 5,
          matrices: "Ad Sales %",
          backend_matrice_name: 'ad_sales_perc'
        };
        let gross_sales_sellerObj: DynamicObject = {
          id: 6,
          matrices: "Gross Sales (Seller)",
          backend_matrice_name: 'gross_sales_seller'
        };
        let gross_sales_vendorObj: DynamicObject = {
          id: 7,
          matrices: "Gross Sales (Vendor)",
          backend_matrice_name: 'gross_sales_vendor'
        };
        let organic_salesObj: DynamicObject = {
          id: 8,
          matrices: "Organic Sales",
          backend_matrice_name: 'organic_sales'
        };
        let organic_sales_percObj: DynamicObject = {
          id: 9,
          matrices: "Organic Sales %",
          backend_matrice_name: 'organic_sales_perc'
        };
        let ordersObj: DynamicObject = {
          id: 10,
          matrices: "Ad Orders",
          backend_matrice_name: 'orders'
        };
        let unitsObj: DynamicObject = {
          id: 11,
          matrices: "Ad Units",
          backend_matrice_name: 'units'
        }; 
        let gross_units_sellerObj: DynamicObject = {
          id: 12,
          matrices: "Gross Units (Seller)",
          backend_matrice_name: 'gross_units_seller',
        };
        let gross_units_vendorObj: DynamicObject = {
          id: 13,
          matrices: "Gross Units (Vendor)",
          backend_matrice_name: 'gross_units_vendor',
        };
        let organic_unitsObj: DynamicObject = {
          id: 14,
          matrices: "Organic Units",
          backend_matrice_name: 'organic_units',
        };
        let acosObj: DynamicObject = {
          id: 15,
          matrices: "ACOS",
          backend_matrice_name: 'acos',
        };
        let tacosObj: DynamicObject = {
          id: 16,
          matrices: "TACOS",
          backend_matrice_name: 'tacos',
        };
        let roasObj: DynamicObject = {
          id: 17,
          matrices: "ROAS",
          backend_matrice_name: 'roas',
        };
        let troasObj: DynamicObject = {
          id: 18,
          matrices: "TROAS",
          backend_matrice_name: 'troas',
        };
        let ctrObj: DynamicObject = {
          id: 19,
          matrices: "CTR",
          backend_matrice_name: 'ctr',
        };
        let cvrObj: DynamicObject = {
          id: 20,
          matrices: "CVR",
          backend_matrice_name: 'cvr',
        };
        let cpcObj: DynamicObject = {
          id: 21,
          matrices: "CPC",
          backend_matrice_name: 'cpc',
        };
        let aovObj: DynamicObject = {
          id: 22,
          matrices: "AOV",
          backend_matrice_name: 'aov',
        };
        let cacObj: DynamicObject = {
          id: 23,
          matrices: "CAC",
          backend_matrice_name: 'cac',
        };
        let gross_glanceviewsObj: DynamicObject = {
          id: 24,
          matrices: "Glance View",
          backend_matrice_name: 'gross_glanceviews',
        };
        

        for (let el of results) {
          let {
            date,
            impressions,
            clicks,
            cost,
            sales,
            units,
            ad_sales_perc,
            gross_sales_seller,
            gross_sales_vendor,
            organic_sales,
            organic_sales_perc,
            orders,
            gross_units_seller,
            gross_units_vendor,
            organic_units,
            acos,
            tacos,
            roas,
            troas,
            ctr,
            cvr,
            cpc,
            aov,
            cac,
            gross_glanceviews,
          } = el;
          if (type === "day") {
            impressionsObj[date] = Number(impressions);
            clicksObj[date] = Number(clicks);
            costObj[date] = Number(cost);
            salesObj[date] = Number(sales);
            ad_sales_percObj[date] = Number(ad_sales_perc);
            gross_sales_sellerObj[date] = Number(gross_sales_seller ?? 0);
            gross_sales_vendorObj[date] = Number(gross_sales_vendor ?? 0);
            organic_salesObj[date] = Number(organic_sales);
            organic_sales_percObj[date] = Number(organic_sales_perc);
            ordersObj[date] = Number(orders);
            unitsObj[date] = Number(units);
            gross_units_sellerObj[date] = Number(gross_units_seller ?? 0);
            gross_units_vendorObj[date] = Number(gross_units_vendor ?? 0);
            organic_unitsObj[date] = Number(organic_units);
            acosObj[date] = Number(acos);
            tacosObj[date] = Number(tacos);
            roasObj[date] = Number(roas);
            troasObj[date] = Number(troas);
            ctrObj[date] = Number(ctr);
            cvrObj[date] = Number(cvr);
            cpcObj[date] = Number(cpc);
            aovObj[date] = Number(aov);
            cacObj[date] = Number(cac);
            gross_glanceviewsObj[date] = Number(gross_glanceviews);
          } else if (type === "week") {
            const [year, month, week_name, week] = date?.split("-");
 
            impressionsObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(impressions);
            clicksObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(clicks);
            costObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(cost);
            salesObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(sales);
            ad_sales_percObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(ad_sales_perc);

            gross_sales_sellerObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_sales_seller ?? 0);
            gross_sales_vendorObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_sales_vendor ?? 0);

            organic_salesObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(organic_sales);
            organic_sales_percObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(organic_sales_perc);
            ordersObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(orders);
            unitsObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(units);

            gross_units_sellerObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_units_seller ?? 0);
            gross_units_vendorObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_units_vendor ?? 0);

            organic_unitsObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(organic_units);
            acosObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(acos);
            tacosObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(tacos);
            roasObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(roas);
            troasObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(troas);
            ctrObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(ctr);
            cvrObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(cvr);
            cpcObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(cpc);
            aovObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(aov);
            cacObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(cac);
            gross_glanceviewsObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_glanceviews);
          } else if (type === "month") {
            const [year, month, week_name, week] = date?.split("-");
            impressionsObj[ `${formatMonthYear({ year, month })}`] = Number(impressions);
            clicksObj[ `${formatMonthYear({ year, month })}`] = Number(clicks);
            costObj[ `${formatMonthYear({ year, month })}`] = Number(cost);
            salesObj[ `${formatMonthYear({ year, month })}`] = Number(sales);
            ad_sales_percObj[ `${formatMonthYear({ year, month })}`] = Number(ad_sales_perc);

            gross_sales_sellerObj[`${formatMonthYear({ year, month })}`] = Number(gross_sales_seller ?? 0);
            gross_sales_vendorObj[`${formatMonthYear({ year, month })}`] = Number(gross_sales_vendor ?? 0);

            organic_salesObj[ `${formatMonthYear({ year, month })}`] = Number(organic_sales);
            organic_sales_percObj[ `${formatMonthYear({ year, month })}`] = Number(organic_sales_perc);
            ordersObj[ `${formatMonthYear({ year, month })}`] = Number(orders);
            unitsObj[ `${formatMonthYear({ year, month })}`] = Number(units);

            gross_units_sellerObj[`${formatMonthYear({ year, month })}`] = Number(gross_units_seller ?? 0);
            gross_units_vendorObj[`${formatMonthYear({ year, month })}`] = Number(gross_units_vendor ?? 0);

            organic_unitsObj[ `${formatMonthYear({ year, month })}`] = Number(organic_units);
            acosObj[ `${formatMonthYear({ year, month })}`] = Number(acos);
            tacosObj[ `${formatMonthYear({ year, month })}`] = Number(tacos);
            roasObj[ `${formatMonthYear({ year, month })}`] = Number(roas);
            troasObj[ `${formatMonthYear({ year, month })}`] = Number(troas);
            ctrObj[ `${formatMonthYear({ year, month })}`] = Number(ctr);
            cvrObj[ `${formatMonthYear({ year, month })}`] = Number(cvr);
            cpcObj[ `${formatMonthYear({ year, month })}`] = Number(cpc);
            aovObj[ `${formatMonthYear({ year, month })}`] = Number(aov);
            cacObj[ `${formatMonthYear({ year, month })}`] = Number(cac);
            gross_glanceviewsObj[ `${formatMonthYear({ year, month })}`] = Number(gross_glanceviews);
          } else if (type === "all") {

            impressionsObj["All"] = Number(impressions);
            clicksObj["All"] = Number(clicks);
            costObj["All"] = Number(cost);
            salesObj["All"] = Number(sales);
            ad_sales_percObj["All"] = Number(ad_sales_perc);

            gross_sales_sellerObj["All"] = Number(gross_sales_seller ?? 0);
            gross_sales_vendorObj["All"] = Number(gross_sales_vendor ?? 0);

            organic_salesObj["All"] = Number(organic_sales);
            organic_sales_percObj["All"] = Number(organic_sales_perc);
            ordersObj["All"] = Number(orders);
            unitsObj["All"] = Number(units);

            gross_units_sellerObj["All"] = Number(gross_units_seller ?? 0);
            gross_units_vendorObj["All"] = Number(gross_units_vendor ?? 0);
            
            organic_unitsObj["All"] = Number(organic_units);
            acosObj["All"] = Number(acos);
            tacosObj["All"] = Number(tacos);
            roasObj["All"] = Number(roas);
            troasObj["All"] = Number(troas);
            ctrObj["All"] = Number(ctr);
            cvrObj["All"] = Number(cvr);
            cpcObj["All"] = Number(cpc);
            aovObj["All"] = Number(aov);
            cacObj["All"] = Number(cac);
            gross_glanceviewsObj["All"] = Number(gross_glanceviews);
          }
        }

        new_arr = [
          impressionsObj,
          clicksObj,
          costObj,
          salesObj,
          ad_sales_percObj,
          gross_sales_sellerObj,
          gross_sales_vendorObj,
          organic_salesObj,
          organic_sales_percObj,
          ordersObj,
          unitsObj,
          gross_units_sellerObj,
          gross_units_vendorObj,
          organic_unitsObj,
          acosObj,
          tacosObj,
          roasObj,
          troasObj,
          ctrObj,
          cvrObj,
          cpcObj,
          aovObj,
          cacObj,
          gross_glanceviewsObj,
        ];
        const positionMap = new Map(
          ip_matrices
            .filter((matrice) => matrice.toggle) // Include only toggled items
            .map((matrice) => [matrice.id, matrice.position]) // Map id to position
        );

        // Filter and sort fetchData based on matricesData
        const sortedAndFilteredData = new_arr
          .filter((item) => positionMap.has(item.id)) // Keep only items in matricesData
          .sort(
            (a, b) => (positionMap.get(a.id) ?? 0) - (positionMap.get(b.id) ?? 0)
          ); // Sort by position
          
        const cleanedData = sortedAndFilteredData?.map(((item: DataProps) => {
          const new_obj: DataProps = {};
          for(let key in item){
            if(key !== 'id' && key !== 'backend_matrice_name' && key !== 'matrices'){
              new_obj[key] = item[key];
            }
            if(key === 'matrices'){
              new_obj['Matrices'] = item[key];
            }
          }
          return new_obj;
        }));

        downloadCSV(cleanedData, "OverviewSummaryData.csv"); 

      } else if(ip_transposeFormat === "HORIZONTAL"){            
        // Now map each result to a row object
        new_arr = results.map((el : any) => {
          let dateLabel = "";
      
          if (type === "day") {
            dateLabel = formatDatefunc({ date: el.date });
          } else if (type === "week") {
            const [year, month, , week] = el.date.split("-");
            dateLabel = formatWeekInput({ year, month, week });
          } else if (type === "month") {
            const [year, month] = el.date.split("-");
            dateLabel = formatMonthYear({ year, month });
          } else if (type === "all") {
            dateLabel = "All";
          }
      
          return {
            date: dateLabel,
            impressions: Number(el.impressions),
            clicks: Number(el.clicks),
            cost: Number(el.cost),
            sales: Number(el.sales),
            ad_sales_perc: Number(el.ad_sales_perc),
            gross_sales_seller: Number(el.gross_sales_seller ?? 0),
            gross_sales_vendor: Number(el.gross_sales_vendor ?? 0),
            organic_sales: Number(el.organic_sales),
            organic_sales_perc: Number(el.organic_sales_perc),
            orders: Number(el.orders),
            units: Number(el.units),
            gross_units_seller: Number(el.gross_units_seller ?? 0),
            gross_units_vendor: Number(el.gross_units_vendor ?? 0),
            organic_units: Number(el.organic_units),
            acos: Number(el.acos),
            tacos: Number(el.tacos),
            roas: Number(el.roas),
            troas: Number(el.troas),
            ctr: Number(el.ctr),
            cvr: Number(el.cvr),
            cpc: Number(el.cpc),
            aov: Number(el.aov),
            cac: Number(el.cac),
            gross_glanceviews: Number(el.gross_glanceviews),
          };
        });

        const filteredMatrices = ip_matrices?.filter(m => m?.toggle) // or use a.position - b.position if you prefer hierarchy based on `position`

        const backendKeys = filteredMatrices?.map(m => m?.backend_matrice_name);

        const transformedData = new_arr?.map(entry => {
          const filteredEntry: any = {
            date: entry.date, // Keep the date
          };

          for (const key of backendKeys) {
            filteredEntry[key] = entry[key];
          }

          return filteredEntry;
        });

        const cleanedData = transformedData?.map((item: DataProps) => {
          const new_obj: DataProps = {};
          for(let key in item) {
            if(key === 'date'){
              if(ip_filter?.type === 'day'){
                new_obj['Dates'] = item[key];
              } else if(ip_filter?.type === 'week'){
                new_obj['Weeks'] = item[key];
              } else if(ip_filter?.type === 'month'){
                new_obj['Months'] = item[key];
              } else if(ip_filter?.type === 'all'){
                new_obj['All'] = item[key];
              }
            }
            else {
              const matriceObj = ip_matrices?.find(item => item?.backend_matrice_name === key);
              if(matriceObj){
                new_obj[matriceObj?.matrice_name] = item[key];
              }
            }
          }

          return new_obj;
        });

        downloadCSV(cleanedData, "OverviewSummaryData.csv"); 
      }

    } catch (error) {
      appError(error);
    } finally {
      setExportLoading(false);
      setCustomExportToggle(false);
    }
  };

  const onSegmentCustomExportHandler = async (ip_filter: FilterProps, ip_matrices: Matrice[], ip_transposeFormat: string, ip_startDate: string, ip_endDate: string, ip_selweeks: WeekProps[]) => {
    if (ip_startDate > ip_endDate) {
      appError("The 'From' date cannot be later than the 'Till' date.");
      return;
    }
    const { filter_type, type, year, month } = ip_filter;
    let week =
      ip_selweeks?.length > 0
        ? ip_selweeks
        : ip_startDate && ip_endDate
        ? [[Number(ip_startDate), Number(ip_endDate)]]
        : [];
    const token = localStorage.getItem("token");
    try {
      setExportLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/getSummery?brand_id=${brand_id}`;
      const result = await axios.post(
        api,
        { filter_type, agg_type: type, year, month, week },
        { headers }
      );
      const { results, message } = result?.data?.data;
      let new_arr: any[] = [];
      if(ip_transposeFormat === "VERTICAL"){
        let impressionsObj: DynamicObject = {
          id: 1,
          matrices: "Impressions",
          backend_matrice_name: 'impressions'
        };
        let clicksObj: DynamicObject = {
          id: 2,
          matrices: "Clicks",
          backend_matrice_name: 'clicks'
        };
        let costObj: DynamicObject = {
          id: 3,
          matrices: "Spend",
          backend_matrice_name: 'cost'
        };
        let salesObj: DynamicObject = {
          id: 4,
          matrices: "Ad Sales",
          backend_matrice_name: 'sales'
        };
        let ad_sales_percObj: DynamicObject = {
          id: 5,
          matrices: "Ad Sales %",
          backend_matrice_name: 'ad_sales_perc'
        };
        let gross_sales_sellerObj: DynamicObject = {
          id: 6,
          matrices: "Gross Sales (Seller)",
          backend_matrice_name: 'gross_sales_seller'
        };
        let gross_sales_vendorObj: DynamicObject = {
          id: 7,
          matrices: "Gross Sales (Vendor)",
          backend_matrice_name: 'gross_sales_vendor'
        };
        let organic_salesObj: DynamicObject = {
          id: 8,
          matrices: "Organic Sales",
          backend_matrice_name: 'organic_sales'
        };
        let organic_sales_percObj: DynamicObject = {
          id: 9,
          matrices: "Organic Sales %",
          backend_matrice_name: 'organic_sales_perc'
        };
        let ordersObj: DynamicObject = {
          id: 10,
          matrices: "Ad Orders",
          backend_matrice_name: 'orders'
        };
        let unitsObj: DynamicObject = {
          id: 11,
          matrices: "Ad Units",
          backend_matrice_name: 'units'
        }; 
        let gross_units_sellerObj: DynamicObject = {
          id: 12,
          matrices: "Gross Units (Seller)",
          backend_matrice_name: 'gross_units_seller',
        };
        let gross_units_vendorObj: DynamicObject = {
          id: 13,
          matrices: "Gross Units (Vendor)",
          backend_matrice_name: 'gross_units_vendor',
        };
        let organic_unitsObj: DynamicObject = {
          id: 14,
          matrices: "Organic Units",
          backend_matrice_name: 'organic_units',
        };
        let acosObj: DynamicObject = {
          id: 15,
          matrices: "ACOS",
          backend_matrice_name: 'acos',
        };
        let tacosObj: DynamicObject = {
          id: 16,
          matrices: "TACOS",
          backend_matrice_name: 'tacos',
        };
        let roasObj: DynamicObject = {
          id: 17,
          matrices: "ROAS",
          backend_matrice_name: 'roas',
        };
        let troasObj: DynamicObject = {
          id: 18,
          matrices: "TROAS",
          backend_matrice_name: 'troas',
        };
        let ctrObj: DynamicObject = {
          id: 19,
          matrices: "CTR",
          backend_matrice_name: 'ctr',
        };
        let cvrObj: DynamicObject = {
          id: 20,
          matrices: "CVR",
          backend_matrice_name: 'cvr',
        };
        let cpcObj: DynamicObject = {
          id: 21,
          matrices: "CPC",
          backend_matrice_name: 'cpc',
        };
        let aovObj: DynamicObject = {
          id: 22,
          matrices: "AOV",
          backend_matrice_name: 'aov',
        };
        let cacObj: DynamicObject = {
          id: 23,
          matrices: "CAC",
          backend_matrice_name: 'cac',
        };
        let gross_glanceviewsObj: DynamicObject = {
          id: 24,
          matrices: "Glance View",
          backend_matrice_name: 'gross_glanceviews',
        };

        for (let el of results) {
          let {
            date,
            impressions,
            clicks,
            cost,
            sales,
            units,
            ad_sales_perc,
            gross_sales_seller,
            gross_sales_vendor,
            organic_sales,
            organic_sales_perc,
            orders,
            gross_units_seller,
            gross_units_vendor,
            organic_units,
            acos,
            tacos,
            roas,
            troas,
            ctr,
            cvr,
            cpc,
            aov,
            cac,
            gross_glanceviews,
          } = el;
          if (type === "day") {
            impressionsObj[date] = Number(impressions);
            clicksObj[date] = Number(clicks);
            costObj[date] = Number(cost);
            salesObj[date] = Number(sales);
            ad_sales_percObj[date] = Number(ad_sales_perc);
            gross_sales_sellerObj[date] = Number(gross_sales_seller ?? 0);
            gross_sales_vendorObj[date] = Number(gross_sales_vendor ?? 0);
            organic_salesObj[date] = Number(organic_sales);
            organic_sales_percObj[date] = Number(organic_sales_perc);
            ordersObj[date] = Number(orders);
            unitsObj[date] = Number(units);
            gross_units_sellerObj[date] = Number(gross_units_seller ?? 0);
            gross_units_vendorObj[date] = Number(gross_units_vendor ?? 0);
            organic_unitsObj[date] = Number(organic_units);
            acosObj[date] = Number(acos);
            tacosObj[date] = Number(tacos);
            roasObj[date] = Number(roas);
            troasObj[date] = Number(troas);
            ctrObj[date] = Number(ctr);
            cvrObj[date] = Number(cvr);
            cpcObj[date] = Number(cpc);
            aovObj[date] = Number(aov);
            cacObj[date] = Number(cac);
            gross_glanceviewsObj[date] = Number(gross_glanceviews);
          } else if (type === "week") {
            const [year, month, week_name, week] = date?.split("-");
            impressionsObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(impressions);
            clicksObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(clicks);
            costObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(cost);
            salesObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(sales);
            ad_sales_percObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(ad_sales_perc);
            gross_sales_sellerObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_sales_seller ?? 0);
            gross_sales_vendorObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_sales_vendor ?? 0);
            organic_salesObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(organic_sales);
            organic_sales_percObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(organic_sales_perc);
            ordersObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(orders);
            unitsObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(units);
            gross_units_sellerObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_units_seller ?? 0);
            gross_units_vendorObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_units_vendor ?? 0);
            organic_unitsObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(organic_units);
            acosObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(acos);
            tacosObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(tacos);
            roasObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(roas);
            troasObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(troas);
            ctrObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(ctr);
            cvrObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(cvr);
            cpcObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(cpc);
            aovObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(aov);
            cacObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(cac);
            gross_glanceviewsObj[`${formatWeekInputForCsv({ year, month, week })}`] = Number(gross_glanceviews);
          } else if (type === "month") {
            const [year, month, week_name, week] = date?.split("-");
            impressionsObj[ `${formatMonthYear({ year, month })}`] = Number(impressions);
            clicksObj[ `${formatMonthYear({ year, month })}`] = Number(clicks);
            costObj[ `${formatMonthYear({ year, month })}`] = Number(cost);
            salesObj[ `${formatMonthYear({ year, month })}`] = Number(sales);
            ad_sales_percObj[ `${formatMonthYear({ year, month })}`] = Number(ad_sales_perc);
            gross_sales_sellerObj[`${formatMonthYear({ year, month })}`] = Number(gross_sales_seller ?? 0);
            gross_sales_vendorObj[`${formatMonthYear({ year, month })}`] = Number(gross_sales_vendor ?? 0);
            organic_salesObj[ `${formatMonthYear({ year, month })}`] = Number(organic_sales);
            organic_sales_percObj[ `${formatMonthYear({ year, month })}`] = Number(organic_sales_perc);
            ordersObj[ `${formatMonthYear({ year, month })}`] = Number(orders);
            unitsObj[ `${formatMonthYear({ year, month })}`] = Number(units);
            gross_units_sellerObj[`${formatMonthYear({ year, month })}`] = Number(gross_units_seller ?? 0);
            gross_units_vendorObj[`${formatMonthYear({ year, month })}`] = Number(gross_units_vendor ?? 0);
            organic_unitsObj[ `${formatMonthYear({ year, month })}`] = Number(organic_units);
            acosObj[ `${formatMonthYear({ year, month })}`] = Number(acos);
            tacosObj[ `${formatMonthYear({ year, month })}`] = Number(tacos);
            roasObj[ `${formatMonthYear({ year, month })}`] = Number(roas);
            troasObj[ `${formatMonthYear({ year, month })}`] = Number(troas);
            ctrObj[ `${formatMonthYear({ year, month })}`] = Number(ctr);
            cvrObj[ `${formatMonthYear({ year, month })}`] = Number(cvr);
            cpcObj[ `${formatMonthYear({ year, month })}`] = Number(cpc);
            aovObj[ `${formatMonthYear({ year, month })}`] = Number(aov);
            cacObj[ `${formatMonthYear({ year, month })}`] = Number(cac);
            gross_glanceviewsObj[ `${formatMonthYear({ year, month })}`] = Number(gross_glanceviews);
          } else if (type === "all") {

            impressionsObj["All"] = Number(impressions);
            clicksObj["All"] = Number(clicks);
            costObj["All"] = Number(cost);
            salesObj["All"] = Number(sales);
            ad_sales_percObj["All"] = Number(ad_sales_perc);
            gross_sales_sellerObj["All"] = Number(gross_sales_seller ?? 0);
            gross_sales_vendorObj["All"] = Number(gross_sales_vendor ?? 0);
            organic_salesObj["All"] = Number(organic_sales);
            organic_sales_percObj["All"] = Number(organic_sales_perc);
            ordersObj["All"] = Number(orders);
            unitsObj["All"] = Number(units);
            gross_units_sellerObj["All"] = Number(gross_units_seller ?? 0);
            gross_units_vendorObj["All"] = Number(gross_units_vendor ?? 0);
            organic_unitsObj["All"] = Number(organic_units);
            acosObj["All"] = Number(acos);
            tacosObj["All"] = Number(tacos);
            roasObj["All"] = Number(roas);
            troasObj["All"] = Number(troas);
            ctrObj["All"] = Number(ctr);
            cvrObj["All"] = Number(cvr);
            cpcObj["All"] = Number(cpc);
            aovObj["All"] = Number(aov);
            cacObj["All"] = Number(cac);
            gross_glanceviewsObj["All"] = Number(gross_glanceviews);
          }
        }

        new_arr = [
          impressionsObj,
          clicksObj,
          costObj,
          salesObj,
          ad_sales_percObj,
          gross_sales_sellerObj,
          gross_sales_vendorObj,
          organic_salesObj,
          organic_sales_percObj,
          ordersObj,
          unitsObj,
          gross_units_sellerObj,
          gross_units_vendorObj,
          organic_unitsObj,
          acosObj,
          tacosObj,
          roasObj,
          troasObj,
          ctrObj,
          cvrObj,
          cpcObj,
          aovObj,
          cacObj,
          gross_glanceviewsObj,
        ];
        const positionMap = new Map(
          ip_matrices
            .filter((matrice) => matrice.toggle) // Include only toggled items
            .map((matrice) => [matrice.id, matrice.position]) // Map id to position
        );

        // Filter and sort fetchData based on matricesData
        const sortedAndFilteredData = new_arr
          .filter((item) => positionMap.has(item.id)) // Keep only items in matricesData
          .sort(
            (a, b) => (positionMap.get(a.id) ?? 0) - (positionMap.get(b.id) ?? 0)
          ); // Sort by position

        const cleanedData = sortedAndFilteredData?.map(((item: DataProps) => {
          const new_obj: DataProps = {};
          for(let key in item){
            if(key !== 'id' && key !== 'backend_matrice_name' && key !== 'matrices'){
              new_obj[key] = item[key];
            }
            if(key === 'matrices'){
              new_obj['Matrices'] = item[key];
            }
          }
          return new_obj;
        }));
        downloadCSV(cleanedData, "OverviewSummaryData.csv"); 

      } else if(ip_transposeFormat === "HORIZONTAL"){
          let horizontalData: DynamicObject[] = [];
        
          for (let el of results) {
            const {
              date,
              impressions,
              clicks,
              cost,
              sales,
              ad_sales_perc,
              gross_sales_seller,
              gross_sales_vendor,
              organic_sales,
              organic_sales_perc,
              orders,
              units,
              gross_units_seller,
              gross_units_vendor,
              organic_units,
              acos,
              tacos,
              roas,
              troas,
              ctr,
              cvr,
              cpc,
              aov,
              cac,
              gross_glanceviews,
            } = el;
        
            let formattedDate = "";
        
            if (type === "day") {
              formattedDate = formatDatefunc({ date });
            } else if (type === "week") {
              const [year, month, week_name, week] = date?.split("-");
              formattedDate = formatWeekInput({ year, month, week });
            } else if (type === "month") {
              const [year, month, week_name, week] = date?.split("-");
              formattedDate = formatMonthYear({ year, month });
            } else if (type === "all") {
              formattedDate = "All";
            }
        
            horizontalData.push({
              date: formattedDate,
              impressions: Number(impressions),
              clicks: Number(clicks),
              cost: Number(cost),
              sales: Number(sales),
              ad_sales_perc: Number(ad_sales_perc),
              gross_sales_seller: Number(gross_sales_seller ?? 0),
              gross_sales_vendor: Number(gross_sales_vendor ?? 0),
              organic_sales: Number(organic_sales),
              organic_sales_perc: Number(organic_sales_perc),
              orders: Number(orders),
              units: Number(units),
              gross_units_seller: Number(gross_units_seller ?? 0),
              gross_units_vendor: Number(gross_units_vendor ?? 0),
              organic_units: Number(organic_units),
              acos: Number(acos),
              tacos: Number(tacos),
              roas: Number(roas),
              troas: Number(troas),
              ctr: Number(ctr),
              cvr: Number(cvr),
              cpc: Number(cpc),
              aov: Number(aov),
              cac: Number(cac),
              gross_glanceviews: Number(gross_glanceviews),
            });
          }

          const filteredMatrices = ip_matrices?.filter(m => m?.toggle) // or use a.position - b.position if you prefer hierarchy based on `position`

          const backendKeys = filteredMatrices?.map(m => m?.backend_matrice_name);
  
          const transformedData = horizontalData?.map(entry => {
            const filteredEntry: any = {
              date: entry.date, // Keep the date
            };
  
            for (const key of backendKeys) {
              filteredEntry[key] = entry[key];
            }
  
            return filteredEntry;
          });
  
          const cleanedData = transformedData?.map((item: DataProps) => {
            const new_obj: DataProps = {};
            for(let key in item) {
              if(key === 'date'){
                if(ip_filter?.type === 'day'){
                  new_obj['Dates'] = item[key];
                } else if(ip_filter?.type === 'week'){
                  new_obj['Weeks'] = item[key];
                } else if(ip_filter?.type === 'month'){
                  new_obj['Months'] = item[key];
                } else if(ip_filter?.type === 'all'){
                  new_obj['All'] = item[key];
                }
              }
              else {
                const matriceObj = ip_matrices?.find(item => item?.backend_matrice_name === key);
                if(matriceObj){
                  new_obj[matriceObj?.matrice_name] = item[key];
                }
              }
            }
  
            return new_obj;
          });
  
          downloadCSV(cleanedData, "OverviewSummaryData.csv"); 
        
      }

    } catch (error) {
      appError(error);
    } finally {
      setExportLoading(false);
      setCustomExportToggle(false);
    }
  };

  const exportCustomHandler = async (ip_filter: FilterProps, ip_matrices: Matrice[], ip_transposeFormat: string, ip_startDate: string, ip_endDate: string, ip_selweeks: WeekProps[]) => {
    if (
      ip_filter?.filter_type === "TIMELINE" &&
      ip_filter?.start_date &&
      ip_filter?.end_date &&
      brand_id
    ) {
      onTimelineCustomExportHandler(ip_filter, ip_matrices, ip_transposeFormat);
    } else if (
      ip_filter?.filter_type === "SEGMENT" &&
      (ip_filter?.month.length > 0 &&
        ip_filter?.year.length > 0 &&
        ip_filter?.week.length > 0) &&
      brand_id
    ) {
      onSegmentCustomExportHandler(ip_filter, ip_matrices, ip_transposeFormat, ip_startDate, ip_endDate, ip_selweeks);
    }
  }

  const stage_1 = [
      {frontend_name: 'PRODUCT VIEW', backend_name: 'product'},
      {frontend_name: 'AD TYPE VIEW', backend_name: 'ad_type'},
      {frontend_name: 'CAMPAIGN VIEW', backend_name: 'campaign'},
      {frontend_name: 'TARGETING VIEW', backend_name: 'targeting'},
      {frontend_name: 'BCG VIEW', backend_name: 'bcg'},
      {frontend_name: 'CST VIEW', backend_name: 'cst'},
      {frontend_name: 'PLACEMENT VIEW', backend_name: 'placement'}
    ];

  const stage_2 = [
    {frontend_name: 'TOP PERFORMER', backend_name: "TOP"},
    {frontend_name: 'BOTTOM PERFORMER', backend_name: "BOTTOM"},
  ];

  const product_view_stage_3 = ['CATEGORIES', 'SUBCATEGORIES', 'PRODUCT NAMES'];
  const [campaign_view_stage_3, setCampaign_view_stage_3] = useState<string[]>(['BY SALES', 'BY ACOS', 'BY ORDERS']);

  const [view, setView] = useState<string>('product');
  const [performer, setPerformer] = useState<string>("TOP");
  const [product_detail, setProduct_detail] = useState<string>('CATEGORIES');

  const [section2Toggle, setSection2Toggle] = useState<boolean>(false);
  const [metricsToggle, setMetricsToggle] = useState<boolean>(false);
  const [matricesDataDrawer2, setMatricesDataDrawer2] = useState<Matrice[]>([ 
    {
      id: 1,
      matrice_name: "ACOS",
      backend_matrice_name: "acos",
      toggle: true,
      position: 0,
    },
    {
      id: 2,
      matrice_name: "AOV",
      backend_matrice_name: "aov",
      toggle: false,
      position: 1,
    },
    {
      id: 3,
      matrice_name: "CAC",
      backend_matrice_name: "cac",
      toggle: false,
      position: 2,
    },
    {
      id: 4,
      matrice_name: "Clicks",
      backend_matrice_name: "clicks",
      toggle: false,
      position: 3,
    },
    {
      id: 5,
      matrice_name: "CPC",
      backend_matrice_name: "cpc",
      toggle: false,
      position: 4,
    },
    {
      id: 6,
      matrice_name: "CTR",
      backend_matrice_name: "ctr",
      toggle: false,
      position: 5,
    },
    {
      id: 7,
      matrice_name: "CVR",
      backend_matrice_name: "cvr",
      toggle: false,
      position: 6,
    },
    {
      id: 8,
      matrice_name: "Gross Sales",
      backend_matrice_name: "gross_sales",
      toggle: true,
      position: 7,
    },
    {
      id: 9,
      matrice_name: "Gross Units",
      backend_matrice_name: "gross_units",
      toggle: true,
      position: 8,
    },
    {
      id: 10,
      matrice_name: "Impressions",
      backend_matrice_name: "impressions",
      toggle: false,
      position: 9,
    },
    {
      id: 11,
      matrice_name: "Ad Orders",
      backend_matrice_name: "orders",
      toggle: true,
      position: 10,
    },
    // {
    //   id: 12,
    //   matrice_name: "ROI",
    //   backend_matrice_name: "roi",
    //   toggle: false,
    //   position: 11,
    // },
    {
      id: 12,
      matrice_name: "Ad Sales",
      backend_matrice_name: "sales",
      toggle: true,
      position: 11,
    },
    {
      id: 13,
      matrice_name: "Spend",
      backend_matrice_name: "spend",
      toggle: true,
      position: 12,
    },
    {
      id: 14,
      matrice_name: "TACOS",
      backend_matrice_name: "tacos",
      toggle: false,
      position: 13,
    },
    // {
    //   id: 16,
    //   matrice_name: "TROI",
    //   backend_matrice_name: "troi",
    //   toggle: false,
    //   position: 15,
    // },
    {
      id: 15,
      matrice_name: "Ad Units",
      backend_matrice_name: "units",
      toggle: false,
      position: 14,
    },
  ]);
  const [metricsData2, setMetricsData2] = useState<Matrice[]>([ 
    {
      id: 1,
      matrice_name: "ACOS",
      backend_matrice_name: "acos",
      toggle: true,
      position: 0,
    },
    {
      id: 2,
      matrice_name: "AOV",
      backend_matrice_name: "aov",
      toggle: false,
      position: 1,
    },
    {
      id: 3,
      matrice_name: "CAC",
      backend_matrice_name: "cac",
      toggle: false,
      position: 2,
    },
    {
      id: 4,
      matrice_name: "Clicks",
      backend_matrice_name: "clicks",
      toggle: false,
      position: 3,
    },
    {
      id: 5,
      matrice_name: "CPC",
      backend_matrice_name: "cpc",
      toggle: false,
      position: 4,
    },
    {
      id: 6,
      matrice_name: "CTR",
      backend_matrice_name: "ctr",
      toggle: false,
      position: 5,
    },
    {
      id: 7,
      matrice_name: "CVR",
      backend_matrice_name: "cvr",
      toggle: false,
      position: 6,
    },
    {
      id: 8,
      matrice_name: "Gross Sales",
      backend_matrice_name: "gross_sales",
      toggle: true,
      position: 7,
    },
    {
      id: 9,
      matrice_name: "Gross Units",
      backend_matrice_name: "gross_units",
      toggle: true,
      position: 8,
    },
    {
      id: 10,
      matrice_name: "Impressions",
      backend_matrice_name: "impressions",
      toggle: false,
      position: 9,
    },
    {
      id: 11,
      matrice_name: "Ad Orders",
      backend_matrice_name: "orders",
      toggle: true,
      position: 10,
    },
    // {
    //   id: 12,
    //   matrice_name: "ROI",
    //   backend_matrice_name: "roi",
    //   toggle: false,
    //   position: 11,
    // },
    {
      id: 12,
      matrice_name: "Ad Sales",
      backend_matrice_name: "sales",
      toggle: true,
      position: 11,
    },
    {
      id: 13,
      matrice_name: "Spend",
      backend_matrice_name: "spend",
      toggle: true,
      position: 12,
    },
    {
      id: 14,
      matrice_name: "TACOS",
      backend_matrice_name: "tacos",
      toggle: false,
      position: 13,
    },
    // {
    //   id: 16,
    //   matrice_name: "TROI",
    //   backend_matrice_name: "troi",
    //   toggle: false,
    //   position: 15,
    // },
    {
      id: 15,
      matrice_name: "Ad Units",
      backend_matrice_name: "units",
      toggle: false,
      position: 14,
    },
  ]);
  const [resetToggle2, setResetToggle2] = useState<boolean>(false);
  const [section2ColDefs, setSection2ColDefs] = useState<ColDef<any>[]>([]);
  const [section2Data, setSection2Data] = useState<any[]>([]);
  const [agGridSection2Width, setAgGridSection2Width] = useState<number>(0);
  const getRankedOpacityColor  = (
    value: number,
    columnValues: number[],
    baseHexColor: string
  ): string => {
    // Step 1: Sort and remove duplicates (optional if needed)
    const sorted = [...columnValues]?.sort((a, b) => b - a); // Descending
  
    // Step 2: Find the rank index (0 = highest value)
    const rank = sorted.indexOf(value);
  
    // Step 3: Define number of steps
    const steps = columnValues?.length;
  
    // Step 4: Calculate opacity range (e.g., from 1 to 0.2)
    const maxOpacity = 1;
    const minOpacity = 0.2;
    const stepOpacity = (maxOpacity - minOpacity) / (steps - 1);
  
    const opacity = maxOpacity - rank * stepOpacity;
  
    // Step 5: Convert hex to rgba with opacity
    const rgba = hexToRgba(baseHexColor, opacity);
    return rgba;
  }
  
  const hexToRgba = (hex: string, opacity: number): string => {
    const bigint = parseInt(hex.replace("#", ""), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${opacity.toFixed(2)})`;
  }

  const section2Col1Renderer = (params: any) => {
    return (
      <div
      className="flex px-6 py-2 w-[150px] items-center justify-start gap-2"
      style={{
        // backgroundColor: "#F3F3F7",
      }}
    >
      <div
        style={{
          color: "var(--Text-Primary-Black, #1C1C1E)",
          textAlign: "start",
          fontFamily: "Inter",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "16px",
        }}
      >
        {params?.value}
      </div>
    </div>
    )
  }

  const section2Col1Header = (params: any) => {
    return (
      <div
      className="flex px-2 py-2 w-[150px] items-center justify-start gap-2 h-[100%]"
      style={{
        // backgroundColor: "#F3F3F7",
      }}
    >
      <div
        style={{
          color: "var(--Text-Primary-Black, #1C1C1E)",
          textAlign: "start",
          fontFamily: "Inter",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "16px",
        }}
      >
        {params?.displayName}
      </div>
    </div>
    )
  }

  const section2colors: Record<string, string> = {
    impressions: "#DA9191",
    clicks: "#8C9D6C",
    spend: "#8C9DB6",
    sales: "#9D88C8",
    organic_sales: "#C39155",
    gross_sales: "#599FC4",
    orders: "#D58A62",
    units: "#D5779A",
    organic_units: "#93a1D7",
    gross_units: "#998097",
    acos: "#AD8861",
    tacos: "#7EABAF",
    ctr: "#4F96D4",
    cvr: "#668F7D",
    cpc: "#A17398",
    aov: "#82909B",
    cac: "#BE7C89",
  }

  type MetricSplit = {
    base: string;
    suffix: 'all' | string;
  };
  
  const splitMetricKey = (metricKey: string): MetricSplit => {
    const suffix = 'all';
      if (metricKey.endsWith(`_${suffix}`)) {
        return {
          base: metricKey.slice(0, -1 * (`_${suffix}`.length)),
          suffix
        };
      }
  
    return { base: metricKey, suffix: '' };
  }

  const section2CellRenderer = (params: any) => {
      const metric = splitMetricKey(params?.colDef?.field)?.base;
      const temp_arr = params?.context?.suffixArray?.map((item: any) => Number(item[params?.colDef?.field])); 
      return (
        <div
          className="w-[150px] flex px-6 py-2 items-center justify-end self-stretch gap-2"
          style={{
            backgroundColor: temp_arr?.length > 1 ? getRankedOpacityColor(Number(params?.value), temp_arr, section2colors[metric]) : section2colors[metric],
          }}
        >
          <div
            style={{
              color: "var(--Text-Primary-Black, #1C1C1E)",
              textAlign: "right",
              fontFamily: "Inter",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "16px",
            }}
          >
            {getFormattedValue(params?.value)}
          </div>
        </div>
      );
    };

  const section2HeaderRenderer = (params: any) => {
    return (
      <div
      className="flex px-6 py-2 w-[150px] items-center justify-end self-stretch gap-2"
      style={{
        backgroundColor: "#F3F3F7",
        // backgroundColor: "skyblue"
      }}
    >
      <div
        style={{
          color: "var(--Text-Primary-Black, #1C1C1E)",
          textAlign: "end",
          fontFamily: "Inter",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "16px",
        }}
      >
        {params?.displayName}
      </div>
    </div>
    )
  }

  const fetchSection2Data = async (ag_view: string, ag_performer: string, ag_productDetail: string, filter: FilterProps, ag_metrics: Matrice[]) => {

    let var_selMetrics = ag_metrics?.filter((m) => m?.toggle === true)?.map((item) => item?.backend_matrice_name);

    const var_startDate = `${filter?.start_date?.getFullYear()}-${String(
      filter?.start_date?.getMonth() + 1
    ).padStart(2, "0")}-${String(filter?.start_date?.getDate()).padStart(
      2,
      "0"
    )}`;

    const var_endDate = `${filter?.end_date?.getFullYear()}-${String(
      filter?.end_date.getMonth() + 1
    ).padStart(2, "0")}-${String(filter?.end_date?.getDate()).padStart(
      2,
      "0"
    )}`;

    let metricsColDef = ag_metrics?.filter((m) => m?.toggle === true)?.flatMap((metric) => ({
        field: `${metric.backend_matrice_name}_all`,
        headerName: `${metric.matrice_name} All`,
        sortable: false,
        cellRenderer: section2CellRenderer,
        headerComponent: section2HeaderRenderer,
      })
    );

    let temp_ColDef: ColDef<any>[] = [];
    if(ag_view === 'product'){
      temp_ColDef = [{
        field: ag_productDetail === "CATEGORIES" ? "category" : ag_productDetail === "SUBCATEGORIES" ? "sub_category" : "product_name",
        headerName: ag_productDetail === "CATEGORIES" ? "Category" : ag_productDetail === "SUBCATEGORIES" ? "Sub Category" : "Product Name",
        pinned: 'left',
        headerComponent: section2Col1Header,
        cellRenderer: section2Col1Renderer
      }, ...metricsColDef];
    }
    else if(ag_view === 'ad_type'){
      temp_ColDef = [{
        field: 'ad_type',
        headerName: 'Ad Type',
        pinned: 'left',
        headerComponent: section2Col1Header,
        cellRenderer: section2Col1Renderer
      }, ...metricsColDef];
    }
    else if(ag_view === 'campaign'){
      temp_ColDef = [{
        field: 'campaign_name',
        headerName: 'Campaign',
        pinned: 'left',
        headerComponent: section2Col1Header,
        cellRenderer: section2Col1Renderer
      }, ...metricsColDef];
    }
    else if(ag_view === 'targeting'){
      temp_ColDef = [{
        field: 'targeting',
        headerName: 'Targeting',
        pinned: 'left',
        headerComponent: section2Col1Header,
        cellRenderer: section2Col1Renderer
      }, ...metricsColDef];
    }
    else if(ag_view === 'bcg'){
      temp_ColDef = [{
        field: 'bcg_type',
        headerName: 'Keyword Type',
        pinned: 'left',
        headerComponent: section2Col1Header,
        cellRenderer: section2Col1Renderer
      }, ...metricsColDef];
    }
    else if(ag_view === 'cst'){
      temp_ColDef = [{
        field: 'searchterm',
        headerName: 'CST',
        pinned: 'left',
        headerComponent: section2Col1Header,
        cellRenderer: section2Col1Renderer
      }, ...metricsColDef];
    }
    else if(ag_view === 'placement'){
      temp_ColDef = [{
        field: 'placementclassification',
        headerName: 'Placement',
        pinned: 'left',
        headerComponent: section2Col1Header,
        cellRenderer: section2Col1Renderer
      }, ...metricsColDef];
    }

    const var_TempFilter = 
      filter?.filter_type === "SEGMENT" &&
      filter?.year.length > 0 &&
      filter?.month.length > 0 &&
      filter?.week.length > 0
        ? {
            filter_type: filter?.filter_type,
            year: filter?.year,
            month: filter?.month,
            week: filter?.week,
            agg_type: 'all',
            product_detail_filter: {}
          }
        : {
            filter_type: filter?.filter_type,
            start_date: var_startDate,
            end_date: var_endDate,
            agg_type: 'all',
            product_detail_filter: {}
          };

    type ViewKey = "product" | "ad_type" | "campaign" | "targeting" | "bcg" | "cst" | "placement";
    const var_viewMap: Record<ViewKey, { backend_url: string; payload: any }> = {
      product: {
        backend_url: `sales/getSalesSummary?brand_id=${brand_id}&page=${1}&limit=${ag_productDetail === "SUBCATEGORIES" || ag_productDetail === "CATEGORIES" ? 5 : 20}`,
        payload: {
          filter: var_TempFilter,
          conditions: [],
          sort: {
            metric: "gross_sales",
            period: "all",
            direction: ag_performer === "TOP" ? "DESC" : "ASC"
          },
          product_detail_column: [ag_productDetail === "CATEGORIES" ? "category" : ag_productDetail === "SUBCATEGORIES" ? "sub_category" : "product_name"],
          metrics_column: var_selMetrics
        }
      }, 

      ad_type: {
        backend_url: `ads/getAdsSummary?brand_id=${brand_id}&page=${0}&limit=${0}`,
        payload: {
          filter: var_TempFilter,
          conditions: [],
          sort: {
            metric: "spend",
            period: "all",
            direction: "DESC"
          },
          product_detail_column: ['ad_type'],
          metrics_column: var_selMetrics
        }
      }, 

      campaign:  {
        backend_url: `ads/getAdsSummary?brand_id=${brand_id}&page=${1}&limit=${20}`,
        payload: ag_productDetail === "BY ORDERS" ? {
          filter: var_TempFilter,
          conditions: [
            {metric: "orders", operator: "=", initial_value: 0, dependent_value: 0},
          ],
          sort: {
            metric: "",
            sort_by: "",
            direction: ""
          },
          product_detail_column: ["campaign_name"],
          metrics_column: var_selMetrics
        } : {
          filter: var_TempFilter,
          conditions: [],
          sort: {
            metric: ag_productDetail === "BY SALES" ? "sales" : ag_productDetail === "BY ACOS" ? "acos" : "orders",
            period: "all",
            direction: ag_performer === "TOP" ? "DESC" : "ASC"
          },
          product_detail_column: ["campaign_name"],
          metrics_column: var_selMetrics
        }
      }, 

      targeting: {
        backend_url: `targeting/getTargetingSummary?brand_id=${brand_id}&page=${1}&limit=${50}`,
        payload: ag_productDetail === "BY ORDERS" ? {
          filter: var_TempFilter,
          conditions: [
            {metric: "orders", operator: "=", initial_value: 0, dependent_value: 0},
          ],
          sort: {
            metric: "",
            sort_by: "",
            direction: ""
          },
          product_detail_column: ["targeting"],
          metrics_column: var_selMetrics
        } : {
          filter: var_TempFilter,
          conditions: [],
          sort: {
            metric: ag_productDetail === "BY SALES" ? "sales" : ag_productDetail === "BY ACOS" ? "acos" : "orders",
            period: "all",
            direction: ag_performer === "TOP" ? "DESC" : "ASC"
          },
          product_detail_column: ["targeting"],
          metrics_column: var_selMetrics
        }
      },

      bcg: {
        backend_url: `targeting/getTargetingSummary?brand_id=${brand_id}&page=${0}&limit=${0}`,
        payload: {
          filter: var_TempFilter,
          conditions: [],
          sort: {
            metric: "spend",
            period: "all",
            direction: "DESC"
          },
          product_detail_column: ['bcg_type'],
          metrics_column: var_selMetrics
        }
      },

      cst: {
        backend_url: `searchterm/getSearchTermSummary?brand_id=${brand_id}&page=${1}&limit=${50}`,
        payload: ag_productDetail === "BY ORDERS" ? {
          filter: var_TempFilter,
          conditions: [
            {metric: "orders", operator: "=", initial_value: 0, dependent_value: 0},
          ],
          sort: {
            metric: "",
            sort_by: "",
            direction: ""
          },
          product_detail_column: ["searchterm"],
          metrics_column: var_selMetrics
        } : {
          filter: var_TempFilter,
          conditions: [],
          sort: {
            metric: ag_productDetail === "BY SALES" ? "sales" : ag_productDetail === "BY ACOS" ? "acos" : "orders",
            period: "all",
            direction: ag_performer === "TOP" ? "DESC" : "ASC"
          },
          product_detail_column: ["searchterm"],
          metrics_column: var_selMetrics
        }
      },

      placement: {
        backend_url: `placement/getPlacementSummary?brand_id=${brand_id}&page=${0}&limit=${0}`,
        payload: {
          filter: var_TempFilter,
          conditions: [],
          sort: {
            metric: "spend",
            period: "all",
            direction: "DESC"
          },
          product_detail_column: ['placementclassification'],
          metrics_column: var_selMetrics
        }
      }
    };

    const token = localStorage.getItem("token");
    try {
      setSection2Toggle(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/${var_viewMap[ag_view as ViewKey]?.backend_url}`;
      let body = var_viewMap[ag_view as ViewKey]?.payload;
      const result = await axios.post(api, body, { headers });
      const {results } = result?.data?.data;
      setSection2ColDefs(temp_ColDef);
      let new_section2Data = results?.map((item: any) => {
        const newItem: any = {};
        for (const key in item) {
          if (key !== 'total_count') {
            if(body?.product_detail_column?.includes(key)){
              newItem[key] = item[key] != null ? item[key] : '';
            }
            else {
              newItem[key] = item[key] != null ? Number(item[key]) : 0;
            }
          }          
        }
        return newItem;
      });
      setSection2Data(new_section2Data);
      setAgGridSection2Width(Number(var_selMetrics?.length));
    } catch (error) {
      appError(error);
    } finally {
      setSection2Toggle(false);
    }
  }

  const onChangeStageHandler = async (ag_view: string, ag_performer: string, ag_productDetail: string, ag_matricsData: Matrice[]) => {
    fetchSection2Data(ag_view, ag_performer, ag_productDetail, filter, ag_matricsData);
  }

  const onChangeViewHandler = async (viewBackendName: string) => {
    let new_matrices_data: Matrice[] = [];
    if(viewBackendName === "cst"){
      new_matrices_data = [
        {
          id: 1,
          matrice_name: "ACOS",
          backend_matrice_name: "acos",
          toggle: true,
          position: 0,
        },
        {
          id: 2,
          matrice_name: "AOV",
          backend_matrice_name: "aov",
          toggle: false,
          position: 1,
        },
        {
          id: 3,
          matrice_name: "Clicks",
          backend_matrice_name: "clicks",
          toggle: false,
          position: 2,
        },
        {
          id: 4,
          matrice_name: "CPC",
          backend_matrice_name: "cpc",
          toggle: false,
          position: 3,
        },
        {
          id: 5,
          matrice_name: "CTR",
          backend_matrice_name: "ctr",
          toggle: false,
          position: 4,
        },
        {
          id: 6,
          matrice_name: "CVR",
          backend_matrice_name: "cvr",
          toggle: false,
          position: 5,
        },
        {
          id: 7,
          matrice_name: "Impressions",
          backend_matrice_name: "impressions",
          toggle: false,
          position: 6,
        },
        {
          id: 8,
          matrice_name: "Ad Orders",
          backend_matrice_name: "orders",
          toggle: true,
          position: 7,
        },
        // {
        //   id: 9,
        //   matrice_name: "ROI",
        //   backend_matrice_name: "roi",
        //   toggle: false,
        //   position: 8,
        // },
        {
          id: 9,
          matrice_name: "Ad Sales",
          backend_matrice_name: "sales",
          toggle: true,
          position: 8,
        },
        {
          id: 10,
          matrice_name: "Spend",
          backend_matrice_name: "spend",
          toggle: true,
          position: 9,
        },
        {
          id: 11,
          matrice_name: "Ad Units",
          backend_matrice_name: "units",
          toggle: false,
          position: 10,
        },
        // {
        //   id: 13,
        //   matrice_name: "Units_DRR",
        //   backend_matrice_name: "units_drr",
        //   toggle: false,
        //   position: 12,
        // },
      ];
      setProduct_detail('BY SALES');
      setCampaign_view_stage_3(['BY SALES', 'BY ACOS', 'BY ORDERS']);
      onChangeStageHandler(viewBackendName, "TOP", "BY SALES", new_matrices_data);
      saveLastStateInLocalStorage(viewBackendName, "TOP", "BY SALES", new_matrices_data);
    }

    if(viewBackendName === 'campaign'){
      new_matrices_data = [ 
        {
          id: 1,
          matrice_name: "ACOS",
          backend_matrice_name: "acos",
          toggle: true,
          position: 0,
        },
        {
          id: 2,
          matrice_name: "AOV",
          backend_matrice_name: "aov",
          toggle: false,
          position: 1,
        },
        // {
        //   id: 3,
        //   matrice_name: "CAC",
        //   backend_matrice_name: "cac",
        //   toggle: false,
        //   position: 2,
        // },
        {
          id: 3,
          matrice_name: "Clicks",
          backend_matrice_name: "clicks",
          toggle: false,
          position: 2,
        },
        {
          id: 4,
          matrice_name: "CPC",
          backend_matrice_name: "cpc",
          toggle: false,
          position: 3,
        },
        {
          id: 5,
          matrice_name: "CTR",
          backend_matrice_name: "ctr",
          toggle: false,
          position: 4,
        },
        {
          id: 6,
          matrice_name: "CVR",
          backend_matrice_name: "cvr",
          toggle: false,
          position: 5,
        },
        // {
        //   id: 8,
        //   matrice_name: "Gross Sales",
        //   backend_matrice_name: "gross_sales",
        //   toggle: false,
        //   position: 7,
        // },
        // {
        //   id: 9,
        //   matrice_name: "Gross Units",
        //   backend_matrice_name: "gross_units",
        //   toggle: false,
        //   position: 8,
        // },
        {
          id: 7,
          matrice_name: "Impressions",
          backend_matrice_name: "impressions",
          toggle: false,
          position: 6,
        },
        {
          id: 8,
          matrice_name: "Ad Orders",
          backend_matrice_name: "orders",
          toggle: true,
          position: 7,
        },
        // {
        //   id: 12,
        //   matrice_name: "ROI",
        //   backend_matrice_name: "roi",
        //   toggle: false,
        //   position: 11,
        // },
        {
          id: 9,
          matrice_name: "Ad Sales",
          backend_matrice_name: "sales",
          toggle: true,
          position: 8,
        },
        {
          id: 10,
          matrice_name: "Spend",
          backend_matrice_name: "spend",
          toggle: true,
          position: 9,
        },
        // {
        //   id: 15,
        //   matrice_name: "TACOS",
        //   backend_matrice_name: "tacos",
        //   toggle: false,
        //   position: 14,
        // },
        // {
        //   id: 16,
        //   matrice_name: "TROI",
        //   backend_matrice_name: "troi",
        //   toggle: false,
        //   position: 15,
        // },
        {
          id: 11,
          matrice_name: "Ad Units",
          backend_matrice_name: "units",
          toggle: false,
          position: 10,
        },
      ];
      setProduct_detail('BY SALES');
      setCampaign_view_stage_3(['BY SALES', 'BY ACOS', 'BY ORDERS']);
      onChangeStageHandler(viewBackendName, "TOP", "BY SALES", new_matrices_data);
      saveLastStateInLocalStorage(viewBackendName, "TOP", "BY SALES", new_matrices_data);
    }

    if(viewBackendName === "product"){
      setProduct_detail('CATEGORIES');
      new_matrices_data = [ 
        {
          id: 1,
          matrice_name: "ACOS",
          backend_matrice_name: "acos",
          toggle: true,
          position: 0,
        },
        {
          id: 2,
          matrice_name: "AOV",
          backend_matrice_name: "aov",
          toggle: false,
          position: 1,
        },
        {
          id: 3,
          matrice_name: "CAC",
          backend_matrice_name: "cac",
          toggle: false,
          position: 2,
        },
        {
          id: 4,
          matrice_name: "Clicks",
          backend_matrice_name: "clicks",
          toggle: false,
          position: 3,
        },
        {
          id: 5,
          matrice_name: "CPC",
          backend_matrice_name: "cpc",
          toggle: false,
          position: 4,
        },
        {
          id: 6,
          matrice_name: "CTR",
          backend_matrice_name: "ctr",
          toggle: false,
          position: 5,
        },
        {
          id: 7,
          matrice_name: "CVR",
          backend_matrice_name: "cvr",
          toggle: false,
          position: 6,
        },
        {
          id: 8,
          matrice_name: "Gross Sales",
          backend_matrice_name: "gross_sales",
          toggle: true,
          position: 7,
        },
        {
          id: 9,
          matrice_name: "Gross Units",
          backend_matrice_name: "gross_units",
          toggle: true,
          position: 8,
        },
        {
          id: 10,
          matrice_name: "Impressions",
          backend_matrice_name: "impressions",
          toggle: false,
          position: 9,
        },
        {
          id: 11,
          matrice_name: "Ad Orders",
          backend_matrice_name: "orders",
          toggle: true,
          position: 10,
        },
        // {
        //   id: 12,
        //   matrice_name: "ROI",
        //   backend_matrice_name: "roi",
        //   toggle: false,
        //   position: 11,
        // },
        {
          id: 12,
          matrice_name: "Ad Sales",
          backend_matrice_name: "sales",
          toggle: true,
          position: 11,
        },
        {
          id: 13,
          matrice_name: "Spend",
          backend_matrice_name: "spend",
          toggle: true,
          position: 12,
        },
        {
          id: 14,
          matrice_name: "TACOS",
          backend_matrice_name: "tacos",
          toggle: false,
          position: 13,
        },
        // {
        //   id: 16,
        //   matrice_name: "TROI",
        //   backend_matrice_name: "troi",
        //   toggle: false,
        //   position: 15,
        // },
        {
          id: 15,
          matrice_name: "Ad Units",
          backend_matrice_name: "units",
          toggle: false,
          position: 14,
        },
      ];
      onChangeStageHandler(viewBackendName, "TOP", "CATEGORIES", new_matrices_data);
      saveLastStateInLocalStorage(viewBackendName, "TOP", "CATEGORIES", new_matrices_data);
    }

    if(viewBackendName === 'ad_type'){
      new_matrices_data = [ 
        {
          id: 1,
          matrice_name: "ACOS",
          backend_matrice_name: "acos",
          toggle: true,
          position: 0,
        },
        {
          id: 2,
          matrice_name: "AOV",
          backend_matrice_name: "aov",
          toggle: false,
          position: 1,
        },
        // {
        //   id: 3,
        //   matrice_name: "CAC",
        //   backend_matrice_name: "cac",
        //   toggle: false,
        //   position: 2,
        // },
        {
          id: 3,
          matrice_name: "Clicks",
          backend_matrice_name: "clicks",
          toggle: false,
          position: 2,
        },
        {
          id: 4,
          matrice_name: "CPC",
          backend_matrice_name: "cpc",
          toggle: false,
          position: 3,
        },
        {
          id: 5,
          matrice_name: "CTR",
          backend_matrice_name: "ctr",
          toggle: false,
          position: 4,
        },
        {
          id: 6,
          matrice_name: "CVR",
          backend_matrice_name: "cvr",
          toggle: false,
          position: 5,
        },
        // {
        //   id: 8,
        //   matrice_name: "Gross Sales",
        //   backend_matrice_name: "gross_sales",
        //   toggle: false,
        //   position: 7,
        // },
        // {
        //   id: 9,
        //   matrice_name: "Gross Units",
        //   backend_matrice_name: "gross_units",
        //   toggle: false,
        //   position: 8,
        // },
        {
          id: 7,
          matrice_name: "Impressions",
          backend_matrice_name: "impressions",
          toggle: false,
          position: 6,
        },
        {
          id: 8,
          matrice_name: "Ad Orders",
          backend_matrice_name: "orders",
          toggle: true,
          position: 7,
        },
        // {
        //   id: 12,
        //   matrice_name: "ROI",
        //   backend_matrice_name: "roi",
        //   toggle: false,
        //   position: 11,
        // },
        {
          id: 9,
          matrice_name: "Ad Sales",
          backend_matrice_name: "sales",
          toggle: true,
          position: 8,
        },
        {
          id: 10,
          matrice_name: "Spend",
          backend_matrice_name: "spend",
          toggle: true,
          position: 9,
        },
        // {
        //   id: 15,
        //   matrice_name: "TACOS",
        //   backend_matrice_name: "tacos",
        //   toggle: false,
        //   position: 14,
        // },
        // {
        //   id: 16,
        //   matrice_name: "TROI",
        //   backend_matrice_name: "troi",
        //   toggle: false,
        //   position: 15,
        // },
        {
          id: 11,
          matrice_name: "Ad Units",
          backend_matrice_name: "units",
          toggle: false,
          position: 10,
        },
      ];
      onChangeStageHandler(viewBackendName, performer, product_detail, new_matrices_data);
      saveLastStateInLocalStorage(viewBackendName, performer, product_detail, new_matrices_data);
    }

    if(viewBackendName === 'bcg'){
      new_matrices_data = [
        {
          id: 1,
          matrice_name: "ACOS",
          backend_matrice_name: "acos",
          toggle: true,
          position: 0,
        },
        {
          id: 2,
          matrice_name: "AOV",
          backend_matrice_name: "aov",
          toggle: false,
          position: 1,
        },
        {
          id: 3,
          matrice_name: "Clicks",
          backend_matrice_name: "clicks",
          toggle: false,
          position: 2,
        },
        {
          id: 4,
          matrice_name: "CPC",
          backend_matrice_name: "cpc",
          toggle: false,
          position: 3,
        },
        {
          id: 5,
          matrice_name: "CTR",
          backend_matrice_name: "ctr",
          toggle: false,
          position: 4,
        },
        {
          id: 6,
          matrice_name: "CVR",
          backend_matrice_name: "cvr",
          toggle: false,
          position: 5,
        },
        {
          id: 7,
          matrice_name: "Impressions",
          backend_matrice_name: "impressions",
          toggle: false,
          position: 6,
        },
        {
          id: 8,
          matrice_name: "Ad Orders",
          backend_matrice_name: "orders",
          toggle: true,
          position: 7,
        },
        // {
        //   id: 9,
        //   matrice_name: "ROI",
        //   backend_matrice_name: "roi",
        //   toggle: false,
        //   position: 8,
        // },
        {
          id: 9,
          matrice_name: "Ad Sales",
          backend_matrice_name: "sales",
          toggle: true,
          position: 8,
        },
        {
          id: 10,
          matrice_name: "Spend",
          backend_matrice_name: "spend",
          toggle: true,
          position: 9,
        },
        {
          id: 11,
          matrice_name: "Ad Units",
          backend_matrice_name: "units",
          toggle: false,
          position: 10,
        },
        // {
        //   id: 13,
        //   matrice_name: "Units_DRR",
        //   backend_matrice_name: "units_drr",
        //   toggle: false,
        //   position: 12,
        // },
      ];
      onChangeStageHandler(viewBackendName, performer, product_detail, new_matrices_data);
      saveLastStateInLocalStorage(viewBackendName, performer, product_detail, new_matrices_data);
    }

    if(viewBackendName === 'targeting'){
      new_matrices_data = [
        {
          id: 1,
          matrice_name: "ACOS",
          backend_matrice_name: "acos",
          toggle: true,
          position: 0,
        },
        {
          id: 2,
          matrice_name: "AOV",
          backend_matrice_name: "aov",
          toggle: false,
          position: 1,
        },
        {
          id: 3,
          matrice_name: "Clicks",
          backend_matrice_name: "clicks",
          toggle: false,
          position: 2,
        },
        {
          id: 4,
          matrice_name: "CPC",
          backend_matrice_name: "cpc",
          toggle: false,
          position: 3,
        },
        {
          id: 5,
          matrice_name: "CTR",
          backend_matrice_name: "ctr",
          toggle: false,
          position: 4,
        },
        {
          id: 6,
          matrice_name: "CVR",
          backend_matrice_name: "cvr",
          toggle: false,
          position: 5,
        },
        {
          id: 7,
          matrice_name: "Impressions",
          backend_matrice_name: "impressions",
          toggle: false,
          position: 6,
        },
        {
          id: 8,
          matrice_name: "Ad Orders",
          backend_matrice_name: "orders",
          toggle: true,
          position: 7,
        },
        // {
        //   id: 9,
        //   matrice_name: "ROI",
        //   backend_matrice_name: "roi",
        //   toggle: false,
        //   position: 8,
        // },
        {
          id: 9,
          matrice_name: "Ad Sales",
          backend_matrice_name: "sales",
          toggle: true,
          position: 8,
        },
        {
          id: 10,
          matrice_name: "Spend",
          backend_matrice_name: "spend",
          toggle: true,
          position: 9,
        },
        {
          id: 11,
          matrice_name: "Ad Units",
          backend_matrice_name: "units",
          toggle: false,
          position: 10,
        },
        // {
        //   id: 13,
        //   matrice_name: "Units_DRR",
        //   backend_matrice_name: "units_drr",
        //   toggle: false,
        //   position: 12,
        // },
      ];
      setProduct_detail('BY SALES');
      setCampaign_view_stage_3(['BY SALES', 'BY ACOS', 'BY ORDERS']);
      onChangeStageHandler(viewBackendName, "TOP", "BY SALES", new_matrices_data);
      saveLastStateInLocalStorage(viewBackendName, "TOP", "BY SALES", new_matrices_data);
    }

    if(viewBackendName === "placement"){
      new_matrices_data = [
        {
          id: 1,
          matrice_name: "ACOS",
          backend_matrice_name: "acos",
          toggle: true,
          position: 0,
        },
        {
          id: 2,
          matrice_name: "AOV",
          backend_matrice_name: "aov",
          toggle: false,
          position: 1,
        },
        {
          id: 3,
          matrice_name: "Clicks",
          backend_matrice_name: "clicks",
          toggle: false,
          position: 2,
        },
        {
          id: 4,
          matrice_name: "CPC",
          backend_matrice_name: "cpc",
          toggle: false,
          position: 3,
        },
        {
          id: 5,
          matrice_name: "CTR",
          backend_matrice_name: "ctr",
          toggle: false,
          position: 4,
        },
        {
          id: 6,
          matrice_name: "CVR",
          backend_matrice_name: "cvr",
          toggle: false,
          position: 5,
        },
        {
          id: 7,
          matrice_name: "Impressions",
          backend_matrice_name: "impressions",
          toggle: false,
          position: 6,
        },
        {
          id: 8,
          matrice_name: "Ad Orders",
          backend_matrice_name: "orders",
          toggle: false,
          position: 7,
        },
        // {
        //   id: 9,
        //   matrice_name: "ROI",
        //   backend_matrice_name: "roi",
        //   toggle: false,
        //   position: 8,
        // },
        {
          id: 9,
          matrice_name: "Ad Sales",
          backend_matrice_name: "sales",
          toggle: true,
          position: 8,
        },
        {
          id: 10,
          matrice_name: "Spend",
          backend_matrice_name: "spend",
          toggle: true,
          position: 9,
        },
        {
          id: 11,
          matrice_name: "Ad Units",
          backend_matrice_name: "units",
          toggle: false,
          position: 10,
        },
        // {
        //   id: 13,
        //   matrice_name: "Units_DRR",
        //   backend_matrice_name: "units_drr",
        //   toggle: false,
        //   position: 12,
        // },
      ];
      onChangeStageHandler(viewBackendName, performer, product_detail, new_matrices_data);
      saveLastStateInLocalStorage(viewBackendName, performer, product_detail, new_matrices_data);
    }
    setMetricsData2(new_matrices_data);
    setMatricesDataDrawer2(new_matrices_data);
    setPerformer("TOP");
    setView(viewBackendName);
  }

  const saveLastStateInLocalStorage = (ag_view: string, ag_performer: string, ag_productDetail: string, ag_metrics: Matrice[]) => {
    const section2lastState = {ag_view, ag_performer, ag_productDetail, ag_metrics};

    localStorage.setItem(
      'overview_summary_section2TableData',
      JSON.stringify(section2lastState)
    );
  }

  return (
    <>
      <div className="flex flex-col">
        <div
          className="flex px-[20px] py-3 items-center justify-between gap-1 self-stretch"
          style={{
            borderBottom: "1px solid #EAEAED",
          }}
        >
          <div className="flex items-center gap-2">
            <div
              style={{
                color: "var(--Text-Primary-Black, #1C1C1E)",
                fontFamily: "Inter",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "26px",
              }}
            >
              Overview
            </div>
            <div
              className="flex h-[40px] px-[6px] py-1 items-start rounded-[4px]"
              style={{
                backgroundColor: "#F9F9FB",
              }}
            >
              <div
                className="flex w-[100px] px-4 py-2 justify-center items-center gap-1 self-stretch rounded-[4px] cursor-pointer"
                style={{
                  backgroundColor: location.pathname.includes(
                    "/Ads_dashboard/overview/comparison"
                  )
                    ? "#FFF"
                    : "#F9F9FB",
                  color: location.pathname.includes(
                    "/Ads_dashboard/overview/comparison"
                  )
                    ? "#1565C0"
                    : "#97979A",
                  boxShadow: location.pathname.includes(
                    "/Ads_dashboard/overview/comparison"
                  )
                    ? "0px 4px 16px 16px rgba(130,130,130,0.05)"
                    : "none",
                }}
                onClick={() =>
                  navigate(`/Ads_dashboard/overview/comparison/${brand_id}`)
                }
              >
                <div
                  style={{
                    color: location.pathname.includes(
                      "/Ads_dashboard/overview/comparison"
                    )
                      ? "var(--Text-Event-Blue, #1565C0)"
                      : "#97979A",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "10px",
                    fontStyle: "normal",
                    fontWeight: location.pathname.includes(
                      "/Ads_dashboard/overview/comparison"
                    )
                      ? 600
                      : 500,
                    lineHeight: "10px",
                    letterSpacing: "1.6px",
                    textTransform: "uppercase",
                  }}
                >
                  Comparison
                </div>
              </div>
              <div
                className="flex w-[100px] px-4 py-2 justify-center items-center gap-1 self-stretch rounded-[4px] cursor-pointer"
                style={{
                  backgroundColor: location.pathname.includes(
                    "/Ads_dashboard/overview/summary"
                  )
                    ? "#FFF"
                    : "#F9F9FB",
                  color: location.pathname.includes(
                    "/Ads_dashboard/overview/summary"
                  )
                    ? "#1565C0"
                    : "#97979A",
                  boxShadow: location.pathname.includes(
                    "/Ads_dashboard/overview/summary"
                  )
                    ? "0px 4px 16px 16px rgba(130,130,130,0.05)"
                    : "none",
                }}
                onClick={() =>
                  navigate(`/Ads_dashboard/overview/summary/${brand_id}`)
                }
              >
                <div
                  style={{
                    color: location.pathname.includes(
                      "/Ads_dashboard/overview/summary"
                    )
                      ? "var(--Text-Event-Blue, #1565C0)"
                      : "#97979A",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "10px",
                    fontStyle: "normal",
                    fontWeight: location.pathname.includes(
                      "/Ads_dashboard/overview/summary"
                    )
                      ? 600
                      : 500,
                    lineHeight: "10px",
                    letterSpacing: "1.6px",
                    textTransform: "uppercase",
                  }}
                >
                  SUMMARY
                </div>
              </div>
            </div>
          </div>

          <div
          className="flex  items-center justify-start gap-[10px] "
          // style={{
          //   borderBottom: "1px solid #EAEAED",
          // }}
        >
            
            <div
              className="flex px-[6px] py-[4px] items-center gap-2 rounded-[4px] h-[40px]"
              style={{
                border: "1px solid #EAEAED",
              }}
            >
              <div className="flex flex-col items-start gap-2 self-stretch w-[124px] relative">
                <MultiSelect
                  children={years}
                  selected={selectedYears}
                  onChange={onYearChange}
                  placeholder="Select Years"
                  containerstyle={{
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    // paddingTop: "8px",
                    // paddingBottom: "8px",
                    height: "28px",
                    borderRadius: 8,
                    border: `1px solid ${BLACK.B_5}`,
                  }}
                  fontstyle={{
                    fontSize: "10px",
                    lineHeight: "14px",
                    fontWeight: 400,
                    color: BLACK.B_40,
                  }}
                  checkboxcolor={"primary"}
                  dropdownheight={150}
                />
              </div>

              <div className="flex flex-col items-start gap-2 self-stretch w-[124px] relative">
                <MultiSelect
                  children={months}
                  selected={selectedMonths}
                  onChange={onMonthChange}
                  placeholder="Select Months"
                  containerstyle={{
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    // paddingTop: "8px",
                    // paddingBottom: "8px",
                    height: "28px",
                    borderRadius: 8,
                    border: `1px solid ${BLACK.B_5}`,
                  }}
                  fontstyle={{
                    fontSize: "10px",
                    lineHeight: "14px",
                    fontWeight: 400,
                    color: BLACK.B_40,
                  }}
                  checkboxcolor={"primary"}
                  dropdownheight={150}
                />
              </div>

              <div className="flex flex-col items-start gap-2 self-stretch w-[124px] relative">
                <MultiSelect
                  children={weeks}
                  selected={selectedWeeks}
                  onChange={onWeekChange}
                  placeholder="Select Weeks"
                  containerstyle={{
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    // paddingTop: "8px",
                    // paddingBottom: "8px",
                    height: "28px",
                    borderRadius: 8,
                    border: `1px solid ${BLACK.B_5}`,
                  }}
                  fontstyle={{
                    fontSize: "10px",
                    lineHeight: "14px",
                    fontWeight: 400,
                    color: BLACK.B_40,
                  }}
                  checkboxcolor={"primary"}
                  dropdownheight={150}
                  disabled={startDate && endDate ? true : false}
                />
              </div>

              <div className="flex flex-col items-center gap-[2px]">
                <div
                  style={{
                    border: "1px solid #EAEAED",
                    height: "9px",
                    width: "0px",
                  }}
                ></div>
                <div
                  style={{
                    color: "var(--Text-Primary-Grey, #97979A)",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "8px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "10px", // 125%
                    letterSpacing: "1.6px",
                    textTransform: "uppercase",
                  }}
                >
                  OR
                </div>
                <div
                  style={{
                    border: "1px solid #EAEAED",
                    height: "9px",
                    width: "0px",
                  }}
                ></div>
              </div>

              <input
                type="text"
                placeholder="From"
                name="startDate"
                style={{
                  fontSize: "10px",
                  fontWeight: "400",
                  lineHeight: "14px",
                  color: "#97979A",
                  border: "1px solid #F2F2F5",
                  borderRadius: "4px",
                  paddingTop: "8px",
                  paddingBottom: "8px",
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  width: "60px",
                  backgroundColor: selweeks.length > 0 ? "#F3F3F7" : "#FFF",
                }}
                value={startDate}
                onChange={handleChange}
                disabled={selweeks.length > 0 && true}
              />
              <input
                type="text"
                placeholder="Till"
                name="endDate"
                style={{
                  fontSize: "10px",
                  fontWeight: "400",
                  lineHeight: "14px",
                  color: "#97979A",
                  border: "1px solid #F2F2F5",
                  borderRadius: "4px",
                  paddingTop: "8px",
                  paddingBottom: "8px",
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  width: "60px",
                  backgroundColor: selweeks.length > 0 ? "#F3F3F7" : "#FFF",
                }}
                value={endDate}
                onChange={handleChange}
                disabled={selweeks.length > 0 && true}
              />
            </div>

            <div className="flex flex-col items-center gap-[2px]">
              <div
                style={{
                  border: "1px solid #EAEAED",
                  height: "10px",
                  width: "0px",
                }}
              ></div>
              <div
                style={{
                  color: "var(--Text-Primary-Grey, #97979A)",
                  textAlign: "center",
                  fontFamily: "Inter",
                  fontSize: "8px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "10px", // 125%
                  letterSpacing: "1.6px",
                  textTransform: "uppercase",
                }}
              >
                OR
              </div>
              <div
                style={{
                  border: "1px solid #EAEAED",
                  height: "10px",
                  width: "0px",
                }}
              ></div>
            </div>

            <div
              className="flex items-center py-2 px-4 gap-2 rounded-[4px]"
              style={{
                border: "1px solid #EAEAED",
                position: "relative",
                backgroundColor:
                  filter?.year?.length !== 0 ||
                  filter?.month?.length !== 0 ||
                  filter?.week?.length !== 0
                    ? "#F3F3F7"
                    : "#FFF",
                pointerEvents:
                  filter?.year?.length !== 0 ||
                  filter?.month?.length !== 0 ||
                  filter?.week?.length !== 0
                    ? "none"
                    : "auto",
              }}
            >
              <div className="flex items-center gap-2">
                <div
                  style={{
                    color: "var(--Text-Primary-Black, #1C1C1E)",
                    fontFamily: "Inter",
                    fontSize: "10px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "14px",
                  }}
                >
                  {`${String(filter?.start_date.getDate()).padStart(
                    2,
                    "0"
                  )}/${String(filter?.start_date.getMonth() + 1).padStart(
                    2,
                    "0"
                  )}/${filter?.start_date.getFullYear()} - ${String(
                    filter?.end_date.getDate()
                  ).padStart(2, "0")}/${String(
                    filter?.end_date.getMonth() + 1
                  ).padStart(2, "0")}/${filter?.end_date.getFullYear()} `}
                </div>
              </div>
              <img
                src={CalenderIcon}
                alt="OverView Icon"
                style={{ cursor: "pointer" }}
                onClick={() => setDateToggle(true)}
                ref={dateRangeCmpButtonRef}
              />
              {dateToggle && (
                <div
                  className="absolute "
                  style={{ top: "37px", right: "0px", zIndex: 100 }}
                  ref={dateRangeCmpRef}
                >
                  <DateRangeComponent
                    range={{
                      startDate: filter?.start_date,
                      endDate: filter?.end_date,
                    }}
                    apply={apply}
                    minDate={range?.min_date}
                    maxDate={range?.max_date}
                    setDateToggle={setDateToggle}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {/* <div
          className="flex w-full py-3 px-[40px] items-center justify-start gap-[10px] "
          style={{
            borderBottom: "1px solid #EAEAED",
          }}
        >
          <div
            className="flex items-center py-2 px-4 gap-2 rounded-[4px]"
            style={{
              border: "1px solid #EAEAED",
              position: "relative",
              backgroundColor:
                filter?.year?.length !== 0 ||
                filter?.month?.length !== 0 ||
                filter?.week?.length !== 0
                  ? "#F3F3F7"
                  : "#FFF",
              pointerEvents:
                filter?.year?.length !== 0 ||
                filter?.month?.length !== 0 ||
                filter?.week?.length !== 0
                  ? "none"
                  : "auto",
            }}
          >
            <div className="flex items-center gap-2">
              <div
                style={{
                  color: "var(--Text-Primary-Black, #1C1C1E)",
                  fontFamily: "Inter",
                  fontSize: "10px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "14px",
                }}
              >
                {`${String(filter?.start_date.getDate()).padStart(
                  2,
                  "0"
                )}/${String(filter?.start_date.getMonth() + 1).padStart(
                  2,
                  "0"
                )}/${filter?.start_date.getFullYear()} - ${String(
                  filter?.end_date.getDate()
                ).padStart(2, "0")}/${String(
                  filter?.end_date.getMonth() + 1
                ).padStart(2, "0")}/${filter?.end_date.getFullYear()} `}
              </div>
            </div>
            <img
              src={CalenderIcon}
              alt="OverView Icon"
              style={{ cursor: "pointer" }}
              onClick={() => setDateToggle(true)}
            />
            {dateToggle && (
              <div
                className="absolute "
                style={{ top: "37px", left: "0px", zIndex: 100 }}
              >
                <DateRangeComponent
                  range={{
                    startDate: filter?.start_date,
                    endDate: filter?.end_date,
                  }}
                  apply={apply}
                  minDate={range?.min_date}
                  maxDate={range?.max_date}
                  setDateToggle={setDateToggle}
                />
              </div>
            )}
          </div>

          <div className="flex flex-col items-center gap-[2px]">
            <div
              style={{
                border: "1px solid #EAEAED",
                height: "10px",
                width: "0px",
              }}
            ></div>
            <div
              style={{
                color: "var(--Text-Primary-Grey, #97979A)",
                textAlign: "center",
                fontFamily: "Inter",
                fontSize: "8px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "10px", // 125%
                letterSpacing: "1.6px",
                textTransform: "uppercase",
              }}
            >
              OR
            </div>
            <div
              style={{
                border: "1px solid #EAEAED",
                height: "10px",
                width: "0px",
              }}
            ></div>
          </div>

          <div
            className="flex px-[6px] py-[4px] items-center gap-2 rounded-[4px] h-[40px]"
            style={{
              border: "1px solid #EAEAED",
            }}
          >
            <div className="flex flex-col items-start gap-2 self-stretch w-[124px] relative">
              <MultiSelect
                children={years}
                selected={selectedYears}
                onChange={onYearChange}
                placeholder="Select Years"
                containerstyle={{
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  // paddingTop: "8px",
                  // paddingBottom: "8px",
                  height: "28px",
                  borderRadius: 8,
                  border: `1px solid ${BLACK.B_5}`,
                }}
                fontstyle={{
                  fontSize: "10px",
                  lineHeight: "14px",
                  fontWeight: 400,
                  color: BLACK.B_40,
                }}
                checkboxcolor={"primary"}
                dropdownheight={150}
              />
            </div>

            <div className="flex flex-col items-start gap-2 self-stretch w-[124px] relative">
              <MultiSelect
                children={months}
                selected={selectedMonths}
                onChange={onMonthChange}
                placeholder="Select Months"
                containerstyle={{
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  // paddingTop: "8px",
                  // paddingBottom: "8px",
                  height: "28px",
                  borderRadius: 8,
                  border: `1px solid ${BLACK.B_5}`,
                }}
                fontstyle={{
                  fontSize: "10px",
                  lineHeight: "14px",
                  fontWeight: 400,
                  color: BLACK.B_40,
                }}
                checkboxcolor={"primary"}
                dropdownheight={150}
              />
            </div>

            <div className="flex flex-col items-start gap-2 self-stretch w-[124px] relative">
              <MultiSelect
                children={weeks}
                selected={selectedWeeks}
                onChange={onWeekChange}
                placeholder="Select Weeks"
                containerstyle={{
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  // paddingTop: "8px",
                  // paddingBottom: "8px",
                  height: "28px",
                  borderRadius: 8,
                  border: `1px solid ${BLACK.B_5}`,
                }}
                fontstyle={{
                  fontSize: "10px",
                  lineHeight: "14px",
                  fontWeight: 400,
                  color: BLACK.B_40,
                }}
                checkboxcolor={"primary"}
                dropdownheight={150}
                disabled={startDate && endDate ? true : false}
              />
            </div>

            <div className="flex flex-col items-center gap-[2px]">
              <div
                style={{
                  border: "1px solid #EAEAED",
                  height: "9px",
                  width: "0px",
                }}
              ></div>
              <div
                style={{
                  color: "var(--Text-Primary-Grey, #97979A)",
                  textAlign: "center",
                  fontFamily: "Inter",
                  fontSize: "8px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "10px", // 125%
                  letterSpacing: "1.6px",
                  textTransform: "uppercase",
                }}
              >
                OR
              </div>
              <div
                style={{
                  border: "1px solid #EAEAED",
                  height: "9px",
                  width: "0px",
                }}
              ></div>
            </div>

            <input
              type="text"
              placeholder="From"
              name="startDate"
              style={{
                fontSize: "10px",
                fontWeight: "400",
                lineHeight: "14px",
                color: "#97979A",
                border: "1px solid #F2F2F5",
                borderRadius: "4px",
                paddingTop: "8px",
                paddingBottom: "8px",
                paddingLeft: "16px",
                paddingRight: "16px",
                width: "60px",
                backgroundColor: selweeks.length > 0 ? "#F3F3F7" : "#FFF",
              }}
              value={startDate}
              onChange={handleChange}
              disabled={selweeks.length > 0 && true}
            />
            <input
              type="text"
              placeholder="Till"
              name="endDate"
              style={{
                fontSize: "10px",
                fontWeight: "400",
                lineHeight: "14px",
                color: "#97979A",
                border: "1px solid #F2F2F5",
                borderRadius: "4px",
                paddingTop: "8px",
                paddingBottom: "8px",
                paddingLeft: "16px",
                paddingRight: "16px",
                width: "60px",
                backgroundColor: selweeks.length > 0 ? "#F3F3F7" : "#FFF",
              }}
              value={endDate}
              onChange={handleChange}
              disabled={selweeks.length > 0 && true}
            />
          </div>
        </div> */}

        <div
          className="flex px-[20px] items-center self-stretch"
          style={{
            borderBottom: "1px solid #EAEAED",
          }}
        >
          <div
            style={{
              display: "flex",
              height: "44px",
              padding: "0px 16px",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              borderBottom:
                filter?.type === "day"
                  ? "1px solid #1565C0"
                  : "0px solid #EAEAED",
            }}
            onClick={() => setFilter((prev) => ({ ...prev, ["type"]: "day" }))}
          >
            <div
              style={{
                color:
                  filter?.type === "day"
                    ? "var(--Text-Event-Blue, #1565C0)"
                    : "#97979A",
                textAlign: "center",
                fontFamily: "Inter, sans-serif", // Fallback for font-family
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: filter?.type === "day" ? 600 : 500,
                lineHeight: "12px", // 100% of the font size
                letterSpacing: "1.6px",
                textTransform: "uppercase",
              }}
            >
              DAILY DATA
            </div>
          </div>
          <div
            style={{
              display: "flex",
              height: "44px",
              padding: "0px 16px",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              borderBottom:
                filter?.type === "week"
                  ? "1px solid #1565C0"
                  : "0px solid #EAEAED",
            }}
            onClick={() => setFilter((prev) => ({ ...prev, ["type"]: "week" }))}
          >
            <div
              style={{
                color:
                  filter?.type === "week"
                    ? "var(--Text-Event-Blue, #1565C0)"
                    : "#97979A",
                textAlign: "center",
                fontFamily: "Inter, sans-serif", // Fallback for font-family
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: filter?.type === "week" ? 600 : 500,
                lineHeight: "12px", // 100% of the font size
                letterSpacing: "1.6px",
                textTransform: "uppercase",
              }}
            >
              WEEKLY DATA
            </div>
          </div>
          <div
            style={{
              display: "flex",
              height: "44px",
              padding: "0px 16px",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              borderBottom:
                filter?.type === "month"
                  ? "1px solid #1565C0"
                  : "0px solid #EAEAED",
            }}
            onClick={() =>
              setFilter((prev) => ({ ...prev, ["type"]: "month" }))
            }
          >
            <div
              style={{
                color:
                  filter?.type === "month"
                    ? "var(--Text-Event-Blue, #1565C0)"
                    : "#97979A",
                textAlign: "center",
                fontFamily: "Inter, sans-serif", // Fallback for font-family
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: filter?.type === "month" ? 600 : 500,
                lineHeight: "12px", // 100% of the font size
                letterSpacing: "1.6px",
                textTransform: "uppercase",
              }}
            >
              MONTHLY DATA
            </div>
          </div>
          <div
            style={{
              display: "flex",
              height: "44px",
              padding: "0px 16px",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              borderBottom:
                filter?.type === "all"
                  ? "1px solid #1565C0"
                  : "0px solid #EAEAED",
            }}
            onClick={() => setFilter((prev) => ({ ...prev, ["type"]: "all" }))}
          >
            <div
              style={{
                color:
                  filter?.type === "all"
                    ? "var(--Text-Event-Blue, #1565C0)"
                    : "#97979A",
                textAlign: "center",
                fontFamily: "Inter, sans-serif", // Fallback for font-family
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: filter?.type === "all" ? 600 : 500,
                lineHeight: "12px", // 100% of the font size
                letterSpacing: "1.6px",
                textTransform: "uppercase",
              }}
            >
              ALL DATA
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="px-[20px] flex flex-col" style={{
          overflow: "auto",
          maxHeight: "calc(100vh - 183px)"
        }}>
          <div
            className="flex w-full flex-col items-start rounded-[8px] mt-3 mb-[24px]"
            style={{
              backgroundColor: "#FFF",
              boxShadow: "0px 4px 16px 16px rgba(130,130,130,0.05)",
              // maxHeight: "calc(100vh - 205px)"
            }}
          >
            <div className="flex px-4 py-2 justify-between items-end gap-4 self-stretch">
              <div className="flex flex-col justify-center items-start gap-1">
                <div
                  className="self-stretch"
                  style={{
                    color: "var(--Text-Primary-Black, #1C1C1E)",
                    fontFamily: "Inter",
                    fontSize: "20px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "26px",
                  }}
                >
                  Daily Performance Metrics
                </div>
                <div
                  className="self-stretch"
                  style={{
                    color: "var(--Text-Primary-Grey, #97979A)",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "18px",
                  }}
                >
                  Review the daily performance and metrics in detail.
                </div>
              </div>
              <div className="flex gap-2">
                <div className="flex w-[130px] gap-1">
                    <Select
                      className="w-full"
                      onChange={(e: any, value: any) => setTransposeFormat(value)}
                      name="transpose"
                      value={transposeFormat}
                      indicator={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M9.99984 12.4791C9.88873 12.4791 9.78456 12.4618 9.68734 12.4271C9.59012 12.3923 9.49984 12.3333 9.4165 12.25L5.58317 8.41665C5.43039 8.26387 5.354 8.06942 5.354 7.83331C5.354 7.5972 5.43039 7.40276 5.58317 7.24998C5.73595 7.0972 5.93039 7.02081 6.1665 7.02081C6.40262 7.02081 6.59706 7.0972 6.74984 7.24998L9.99984 10.5L13.2498 7.24998C13.4026 7.0972 13.5971 7.02081 13.8332 7.02081C14.0693 7.02081 14.2637 7.0972 14.4165 7.24998C14.5693 7.40276 14.6457 7.5972 14.6457 7.83331C14.6457 8.06942 14.5693 8.26387 14.4165 8.41665L10.5832 12.25C10.4998 12.3333 10.4096 12.3923 10.3123 12.4271C10.2151 12.4618 10.1109 12.4791 9.99984 12.4791Z"
                            fill="#1C1C1C"
                            fill-opacity="0.4"
                          />
                        </svg>
                      }
                      slotProps={{
                        listbox: {},
                      }}
                      sx={{
                        "--Input-focusedThickness": "0px",
                        height: "32px",
                        color: "#1C1C1E",
                        fontSize: 14,
                        fontWeight: 400,
                        lineHeight: "20px",
                        backgroundColor: WHITE.W_100,
                        boxShadow: "none",
                        border: `1px solid #EAEAED`,
                        [`& .${selectClasses.indicator}`]: {
                          transition: "0.2s",
                          [`&.${selectClasses.expanded}`]: {
                            transform: "rotate(-180deg)",
                          },
                        },
                        ":hover": {
                          backgroundColor: WHITE.W_100,
                        },
                      }}
                    >
                        <Option value={"VERTICAL"}>V-Summary</Option>
                        <Option value={"HORIZONTAL"}>H-Summary</Option>
                    </Select>
                </div>
                <Button
                  color="neutral"
                  sx={{
                    height: 32,
                    width: 80,
                    fontSize: 14,
                    fontWeight: 700,
                    backgroundColor: "#FFF",
                    lineHeight: "20px",
                    color: "#1C1C1E",
                    ":hover": {
                      backgroundColor: "#FFF",
                    },
                    paddingX: "6px",
                    paddingY: 0,
                    gap: "8px",
                    borderRadius: "6px",
                    border: `1px solid #EAEAED`,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => {
                    setRowsToggle(true);
                    // onClearFilterHandler();
                    //   setFilterToggle(false);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M4.42308 9.01434C4.00211 9.01434 3.64579 8.8685 3.35413 8.57684C3.06246 8.28517 2.91663 7.92885 2.91663 7.50788V4.42308C2.91663 4.00211 3.06246 3.64579 3.35413 3.35413C3.64579 3.06246 4.00211 2.91663 4.42308 2.91663H15.5768C15.9978 2.91663 16.3541 3.06246 16.6458 3.35413C16.9375 3.64579 17.0833 4.00211 17.0833 4.42308V7.50788C17.0833 7.92885 16.9375 8.28517 16.6458 8.57684C16.3541 8.8685 15.9978 9.01434 15.5768 9.01434H4.42308ZM4.42308 7.76434H15.5768C15.6517 7.76434 15.7132 7.74031 15.7612 7.69225C15.8093 7.6442 15.8333 7.58274 15.8333 7.50788V4.42308C15.8333 4.34822 15.8093 4.28677 15.7612 4.23871C15.7132 4.19065 15.6517 4.16663 15.5768 4.16663H4.42308C4.34822 4.16663 4.28677 4.19065 4.23871 4.23871C4.19065 4.28677 4.16663 4.34822 4.16663 4.42308V7.50788C4.16663 7.58274 4.19065 7.6442 4.23871 7.69225C4.28677 7.74031 4.34822 7.76434 4.42308 7.76434ZM4.42308 17.0833C4.00211 17.0833 3.64579 16.9375 3.35413 16.6458C3.06246 16.3541 2.91663 15.9978 2.91663 15.5768V12.5C2.91663 12.079 3.06246 11.7227 3.35413 11.431C3.64579 11.1393 4.00211 10.9935 4.42308 10.9935H15.5768C15.9978 10.9935 16.3541 11.1393 16.6458 11.431C16.9375 11.7227 17.0833 12.079 17.0833 12.5V15.5768C17.0833 15.9978 16.9375 16.3541 16.6458 16.6458C16.3541 16.9375 15.9978 17.0833 15.5768 17.0833H4.42308ZM4.42308 15.8333H15.5768C15.6517 15.8333 15.7132 15.8093 15.7612 15.7612C15.8093 15.7132 15.8333 15.6517 15.8333 15.5768V12.5C15.8333 12.4251 15.8093 12.3636 15.7612 12.3156C15.7132 12.2675 15.6517 12.2435 15.5768 12.2435H4.42308C4.34822 12.2435 4.28677 12.2675 4.23871 12.3156C4.19065 12.3636 4.16663 12.4251 4.16663 12.5V15.5768C4.16663 15.6517 4.19065 15.7132 4.23871 15.7612C4.28677 15.8093 4.34822 15.8333 4.42308 15.8333Z"
                      fill="#1C1C1E"
                    />
                  </svg>
                  <div
                    style={{
                      fontSize: "12px",
                      fontWeight: "700",
                      textAlign: "center",
                      lineHeight: "18px",
                      color: "#1C1C1E",
                    }}
                  >
                    Rows
                  </div>
                </Button>
                {/* <Button
                  sx={{
                    backgroundColor: "#FFF",
                    ":hover": {
                      backgroundColor: "#1565C0",
                    },
                    borderRadius: "6px",
                    paddingX: "6px",
                    paddingY: "0px",
                    border: `1px solid #EAEAED`,
                  }}
                >
                  <img
                    src={FullScreenIcon}
                    alt="FullScreen Icon"
                    style={{ cursor: "pointer" }}
                    // onClick={() => setDateToggle(true)}
                  />
                </Button> */}
                <div className=""
                    style={{
                      position: 'relative'
                    }}>
                      <Button
                        sx={{
                          backgroundColor: "#FFF",
                          ":hover": {
                            backgroundColor: "#FFF",
                          },
                          borderRadius: "6px",
                          paddingX: "6px",
                          paddingY: "0px",
                          border: `1px solid #EAEAED`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        ref={exportButtonRef}
                        onClick={() => setExportToggle(prev => !prev)}
                      >
                        <img
                          src={ExportIcon}
                          alt="Export Icon"
                          style={{ cursor: "pointer" }}
                        />
                      </Button>
                      {exportToggle && (
                        <div className="" style={{
                          position: "absolute",
                          top: 42, 
                          right: 0,
                          height: 100,
                          width: 150,
                          backgroundColor: "#FFF",
                          boxShadow: "0px 4px 16px 16px rgba(130,130,130, 0.05)",
                          borderRadius: "8px",
                          display: 'flex',
                          flexDirection: 'column',
                          zIndex: 50
                        }}
                        ref={exportRef}
                        >
                          <div className="p-4"
                          style={{
                            color: "#1C1C1E",
                            textAlign: "start",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "18px",
                            fontFamily: "Inter",
                            cursor: 'pointer'
                          }}
                          onClick={() => {
                            exportSelectionHandler();
                            // setExportToggle(false);
                          }}>
                            Export Selection
                          </div>
                          <div className="p-4"
                          style={{
                            color: "#1C1C1E",
                            textAlign: "start",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "18px",
                            fontFamily: "Inter",
                            cursor: 'pointer'
                          }} onClick={() => {
                            setExportToggle(false);
                            setCustomExportToggle(true);
                          }}>
                            Custom Export
                          </div>
                        </div>
                      )}
                    </div>
                {/* <Button
                  sx={{
                    backgroundColor: "#FFF",
                    ":hover": {
                      backgroundColor: "#FFF",
                    },
                    borderRadius: "6px",
                    paddingX: "6px",
                    paddingY: "0px",
                    border: `1px solid #EAEAED`,
                  }}
                >
                  <img
                    src={ExportIcon}
                    alt="FullScreen Icon"
                    style={{ cursor: "pointer" }}
                    onClick={() =>{
                      if(rawData?.length > 0){
                        downloadCSV(rawData, "OverviewSummaryData.csv");
                      }
                    }}
                  />
                </Button> */}
              </div>
            </div>

            {/* Table */}
            {loading ? (
              <div
                className="flex justify-center items-center"
                style={{
                  height: "calc(100vh - 272px)",
                  width: "100%",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <div
                style={{
                  height: "calc(100vh - 272px)",
                  width: "100%",
                }}
              >
                {datafetchingState === "SUCCESS" && filterdata?.length > 0 && (
                  <div
                    className={"ag-theme-quartz"}
                    style={{
                      maxWidth: "calc(100vw - 72px - 40px)",
                      width: agGridTableWidth,
                      height: "calc(100vh - 272px)",
                      overflowY: "hidden",
                    }}
                  >
                    <style>
                      {`
                .ag-theme-quartz .ag-header {
                  background: #F3F3F7;
                }
                `}
                    </style>
                    <AgGridReact
                      rowData={filterdata}
                      columnDefs={columnDefs}
                      rowHeight={32}
                      headerHeight={36}
                    />
                  </div>
                )}
                {datafetchingState === "EMPTY" && (
                  <div
                    className="flex flex-col gap-10 justify-center items-center"
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="192"
                      height="162"
                      viewBox="0 0 192 162"
                      fill="none"
                    >
                      <g opacity="0.48">
                        <g filter="url(#filter0_di_1399_54050)">
                          <path
                            d="M7.99902 46.0938H167.999V118.475C167.999 128.994 159.471 137.522 148.951 137.522H27.0466C16.5269 137.522 7.99902 128.994 7.99902 118.475V46.0938Z"
                            fill="#DFE3E8"
                          />
                        </g>
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M32.7602 21.332C29.5598 21.332 27.0459 23.8459 27.0459 27.0463C27.0459 30.2459 29.5598 32.7606 32.7602 32.7606C35.9605 32.7606 38.4744 30.2459 38.4744 27.0463C38.4744 23.8459 35.9605 21.332 32.7602 21.332Z"
                          fill="#C4CDD5"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M50.8554 21.332C47.655 21.332 45.1411 23.8459 45.1411 27.0463C45.1411 30.2459 47.655 32.7606 50.8554 32.7606C54.0557 32.7606 56.5696 30.2459 56.5696 27.0463C56.5696 23.8459 54.0557 21.332 50.8554 21.332Z"
                          fill="#C4CDD5"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M68.9505 21.332C65.7502 21.332 63.2363 23.8459 63.2363 27.0463C63.2363 30.2459 65.7502 32.7606 68.9505 32.7606C72.1509 32.7606 74.6648 30.2459 74.6648 27.0463C74.6648 23.8459 72.1509 21.332 68.9505 21.332Z"
                          fill="#C4CDD5"
                        />
                        <g filter="url(#filter1_di_1399_54050)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M167.999 23.2384V46.0951H7.99902L7.99902 23.2398C7.99902 14.8234 14.8219 8 23.2383 8H152.761C161.176 8 167.999 14.8227 167.999 23.2384ZM32.7609 21.3333C29.5605 21.3333 27.0466 23.8472 27.0466 27.0476C27.0466 30.2472 29.5605 32.7618 32.7609 32.7618C35.9612 32.7618 38.4751 30.2472 38.4751 27.0476C38.4751 23.8472 35.9612 21.3333 32.7609 21.3333ZM50.8561 21.3333C47.6557 21.3333 45.1418 23.8472 45.1418 27.0476C45.1418 30.2472 47.6557 32.7618 50.8561 32.7618C54.0564 32.7618 56.5703 30.2472 56.5703 27.0476C56.5703 23.8472 54.0564 21.3333 50.8561 21.3333ZM63.237 27.0476C63.237 23.8472 65.7509 21.3333 68.9512 21.3333C72.1516 21.3333 74.6655 23.8472 74.6655 27.0476C74.6655 30.2472 72.1516 32.7618 68.9512 32.7618C65.7509 32.7618 63.237 30.2472 63.237 27.0476Z"
                            fill="#919EAB"
                          />
                        </g>
                        <path
                          opacity="0.48"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M143.813 58.1484H97.3015C94.7307 58.1484 92.6504 60.2253 92.6504 62.7919V118.514C92.6504 121.081 94.7307 123.157 97.3015 123.157H143.813C146.384 123.157 148.464 121.081 148.464 118.514V62.7919C148.464 60.2253 146.384 58.1484 143.813 58.1484Z"
                          fill="#637381"
                        />
                        <path
                          opacity="0.24"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M32.1853 67.4355H50.7899C53.3608 67.4355 55.4411 65.3586 55.4411 62.7919C55.4411 60.2253 53.3608 58.1484 50.7899 58.1484H32.1853C29.6145 58.1484 27.5342 60.2253 27.5342 62.7919C27.5342 65.3586 29.6145 67.4355 32.1853 67.4355ZM27.5342 81.366C27.5342 78.7993 29.6145 76.7225 32.1853 76.7225H78.6968C81.2677 76.7225 83.348 78.7993 83.348 81.366C83.348 83.9326 81.2677 86.0095 78.6968 86.0095H32.1853C29.6145 86.0095 27.5342 83.9326 27.5342 81.366ZM32.1853 95.2965C29.6145 95.2965 27.5342 97.3734 27.5342 99.94C27.5342 102.507 29.6145 104.583 32.1853 104.583H78.6968C81.2677 104.583 83.348 102.507 83.348 99.94C83.348 97.3734 81.2677 95.2965 78.6968 95.2965H32.1853ZM27.5342 118.514C27.5342 115.947 29.6145 113.87 32.1853 113.87H78.6968C81.2677 113.87 83.348 115.947 83.348 118.514C83.348 121.081 81.2677 123.157 78.6968 123.157H32.1853C29.6145 123.157 27.5342 121.081 27.5342 118.514Z"
                          fill="#637381"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_di_1399_54050"
                          x="-0.000976562"
                          y="38.0938"
                          width="192"
                          height="123.429"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dx="8" dy="8" />
                          <feGaussianBlur stdDeviation="8" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.16 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1399_54050"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_1399_54050"
                            result="shape"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dx="-2" dy="-2" />
                          <feGaussianBlur stdDeviation="2" />
                          <feComposite
                            in2="hardAlpha"
                            operator="arithmetic"
                            k2="-1"
                            k3="1"
                          />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.48 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="shape"
                            result="effect2_innerShadow_1399_54050"
                          />
                        </filter>
                        <filter
                          id="filter1_di_1399_54050"
                          x="-0.000976562"
                          y="0"
                          width="192"
                          height="70.0947"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dx="8" dy="8" />
                          <feGaussianBlur stdDeviation="8" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.16 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1399_54050"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_1399_54050"
                            result="shape"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dx="-2" />
                          <feGaussianBlur stdDeviation="2" />
                          <feComposite
                            in2="hardAlpha"
                            operator="arithmetic"
                            k2="-1"
                            k3="1"
                          />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.48 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="shape"
                            result="effect2_innerShadow_1399_54050"
                          />
                        </filter>
                      </defs>
                    </svg>
                    <div
                      style={{
                        color: "var(--Text-Primary-Grey, #97979A)",
                        textAlign: "center",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "18px",
                      }}
                    >
                      No Result Found. Please Choose Another Filter.
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="flex w-full flex-col items-start rounded-[8px] my-3"
            style={{
              // boxShadow: "0px 4px 16px 16px rgba(130,130,130,0.05)",
              // height: 400
            }}>
              <div
                className="w-full h-[45px] flex items-center justify-start self-stretch mb-[24px]"
                style={{
                  borderBottom: "1px solid #EAEAED",
                }}
              >
                {stage_1?.map((p) => (
                    <div className="flex-1"
                      style={{
                        display: "flex",
                        padding: "0px 16px",
                        justifyContent: "center",
                        alignItems: "center",
                        alignSelf: "stretch",
                        cursor: "pointer",
                        borderBottom:
                          view === p?.backend_name
                            ? "1px solid #1565C0"
                            : "0px",
                      }}
                      key={p?.backend_name}
                      onClick={() => onChangeViewHandler(p?.backend_name)}
                    >
                      <div
                        style={{
                          color:
                            view === p?.backend_name
                              ? "#1565C0"
                              : "var(--Text-Primary-Grey, #97979A)",
                          textAlign: "center",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontStyle: "normal",
                          fontWeight: view === p?.backend_name ? 600 : 500,
                          lineHeight: "10px",
                          letterSpacing: "1.6px",
                          textTransform: "uppercase",
                        }}
                      >
                        {`${p?.frontend_name}`}
                      </div>
                    </div>
                  ))}
              </div>

              {view === "product" ? (
                <ViewComponent1
                  view_type = {view}
                  viewHeaderName="Top and Bottom Performers by Gross Sales Difference"
                  subHeaderName={`${performer === "TOP" ? "Top" : "Bottom"} ${product_detail === "PRODUCT NAMES" ? "20" : "5"} ${product_detail} by ${performer === "TOP" ? "Highest" : "Lowest"} Gross Sales Difference`}
                  performerArr={stage_2}
                  stage_3={product_view_stage_3}
                  performer={performer}
                  product_detail={product_detail}
                  setProduct_detail={setProduct_detail}
                  setPerformer={setPerformer}
                  setMetricsToggle={setMetricsToggle}
                  onChangeStageHandler={onChangeStageHandler}
                  metrics={metricsData2}
                  section2ColDefs={section2ColDefs}
                  section2Data={section2Data}
                  loading={section2Toggle}
                  section2width={agGridSection2Width}
                  saveLastState = {saveLastStateInLocalStorage}
                  />
            ) : view === "ad_type" ? (
                <ViewComponent2 
                  headerName="Ad Type Performance Sorted by Spend from High to Low"
                  setMetricsToggle={setMetricsToggle}
                  section2ColDefs={section2ColDefs}
                  section2Data={section2Data}
                  loading={section2Toggle}
                  section2width={agGridSection2Width}
                  page_name={"summary"}
                />
            ) : view === "campaign" ? (
              <ViewComponent1
                view_type = {view}
                viewHeaderName="Top and Bottom 20 Campaigns by Sales, ACOS and Orders Difference"
                subHeaderName={performer === "TOP" && product_detail === "BY SALES" ? "Top 20 Campaigns by Highest Ad Sales Difference" :  performer === "TOP" && product_detail === "BY ACOS" ? "Top 20 Campaigns by Highest ACOS Difference" : performer === "TOP" && product_detail === "BY ORDERS" ? "Top 20 Campaigns with Ad Orders = 0 by Spend" : performer === "BOTTOM" && product_detail === "BY SALES" ? "Bottom 20 Campaigns by Lowest Ad Sales Difference" :  performer === "BOTTOM" && product_detail === "BY ACOS" ? "Bottom 20 Campaigns by Lowest ACOS Difference" : ""}
                performerArr={stage_2}
                stage_3={campaign_view_stage_3}
                performer={performer}
                product_detail={product_detail}
                setProduct_detail={setProduct_detail}
                setPerformer={setPerformer}
                setMetricsToggle={setMetricsToggle}
                onChangeStageHandler={onChangeStageHandler}
                metrics={metricsData2}
                section2ColDefs={section2ColDefs}
                section2Data={section2Data}
                loading={section2Toggle}
                section2width={agGridSection2Width}
                saveLastState = {saveLastStateInLocalStorage}
                />
            ): view === "targeting" ? (
              <ViewComponent1
                view_type = {view}
                viewHeaderName="Top and Bottom 50 Targeting Based on Sales, ACOS and Orders Difference"
                subHeaderName={performer === "TOP" && product_detail === "BY SALES" ? "Top 50 Targeting Entries by Highest Ad Sales Difference" :  performer === "TOP" && product_detail === "BY ACOS" ? "Top 50 Targeting Entries by Highest ACOS Difference" : performer === "TOP" && product_detail === "BY ORDERS" ? "Top 50 Targeting with Ad Orders by Spend" : performer === "BOTTOM" && product_detail === "BY SALES" ? "Bottom 50 Targeting Entries by Lowest Ad Sales Difference" :  performer === "BOTTOM" && product_detail === "BY ACOS" ? "Bottom 50 Targeting Entries by Lowest ACOS Difference" : ""}
                performerArr={stage_2}
                stage_3={campaign_view_stage_3}
                performer={performer}
                product_detail={product_detail}
                setProduct_detail={setProduct_detail}
                setPerformer={setPerformer}
                setMetricsToggle={setMetricsToggle}
                onChangeStageHandler={onChangeStageHandler}
                metrics={metricsData2}
                section2ColDefs={section2ColDefs}
                section2Data={section2Data}
                loading={section2Toggle}
                section2width={agGridSection2Width}
                saveLastState = {saveLastStateInLocalStorage}
                />
              ) : view === "bcg" ? (
                <ViewComponent2 
                headerName="BCG Analysis Sorted by Spend from High to Low"
                setMetricsToggle={setMetricsToggle}
                section2ColDefs={section2ColDefs}
                section2Data={section2Data}
                loading={section2Toggle}
                section2width={agGridSection2Width}
                page_name={"summary"}
                />
                ) : view === "cst" ? (
                  <ViewComponent1
                  view_type = {view}
                  viewHeaderName="Top and Bottom 50 CST Based on Sales, ACOS and Orders Difference"
                  subHeaderName={performer === "TOP" && product_detail === "BY SALES" ? "Top 50 CST by Highest Ad Sales Difference" :  performer === "TOP" && product_detail === "BY ACOS" ? "Top 50 CST by Highest Ad ACOS Difference" : performer === "TOP" && product_detail === "BY ORDERS" ? "Top 50 CST with Ad Orders = 0 by Spend" : performer === "BOTTOM" && product_detail === "BY SALES" ? "Bottom 50 CST by Lowest Ad Sales Difference" :  performer === "BOTTOM" && product_detail === "BY ACOS" ? "Bottom 50 CST by Lowest ACOS Difference" : ""}
                  performerArr={stage_2}
                  stage_3={campaign_view_stage_3}
                  performer={performer}
                  product_detail={product_detail}
                  setProduct_detail={setProduct_detail}
                  setPerformer={setPerformer}
                  setMetricsToggle={setMetricsToggle}
                  onChangeStageHandler={onChangeStageHandler}
                  metrics={metricsData2}
                  section2ColDefs={section2ColDefs}
                  section2Data={section2Data}
                  loading={section2Toggle}
                  section2width={agGridSection2Width}
                  saveLastState = {saveLastStateInLocalStorage}
                  />
              ) : view === "placement" && (
                  <ViewComponent2 
                  headerName="Placement Analysis Sorted by Spend from High to Low"
                  setMetricsToggle={setMetricsToggle}
                  section2ColDefs={section2ColDefs}
                  section2Data={section2Data}
                  loading={section2Toggle}
                  section2width={agGridSection2Width}
                  page_name={"summary"}
                  />
              )}
          </div>
        </div>


      </div>

      <Drawer
        key={"right"}
        anchor={"right"}
        open={rowsToggle}
        size="md"
        slotProps={{
          backdrop: {
            sx: {
              backdropFilter: "none", // Disable the blur effect
            },
          },
        }}
      >
        <div
          className="flex p-4 items-center justify-between gap-10"
          style={{
            height: 52,
            borderBottom: `1px solid #EAEAED`,
            backgroundColor: "white",
          }}
        >
          <div
            className="self-stretch"
            style={{
              fontSize: 18,
              fontWeight: 500,
              lineHeight: "24px",
              color: BLACK.B_100,
            }}
          >
            Rows
          </div>
          <div
            className="w-fit cursor-pointer"
            onClick={() =>{
              setRowsToggle(false);
              setMatricesDataDrawer(matricesData); 
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M19.2806 18.2194C19.3502 18.289 19.4055 18.3718 19.4432 18.4628C19.4809 18.5539 19.5003 18.6514 19.5003 18.75C19.5003 18.8485 19.4809 18.9461 19.4432 19.0372C19.4055 19.1282 19.3502 19.2109 19.2806 19.2806C19.2109 19.3503 19.1281 19.4056 19.0371 19.4433C18.9461 19.481 18.8485 19.5004 18.7499 19.5004C18.6514 19.5004 18.5538 19.481 18.4628 19.4433C18.3717 19.4056 18.289 19.3503 18.2193 19.2806L11.9999 13.0603L5.78055 19.2806C5.63982 19.4213 5.44895 19.5004 5.24993 19.5004C5.05091 19.5004 4.86003 19.4213 4.7193 19.2806C4.57857 19.1399 4.49951 18.949 4.49951 18.75C4.49951 18.551 4.57857 18.3601 4.7193 18.2194L10.9396 12L4.7193 5.78061C4.57857 5.63988 4.49951 5.44901 4.49951 5.24999C4.49951 5.05097 4.57857 4.8601 4.7193 4.71936C4.86003 4.57863 5.05091 4.49957 5.24993 4.49957C5.44895 4.49957 5.63982 4.57863 5.78055 4.71936L11.9999 10.9397L18.2193 4.71936C18.36 4.57863 18.5509 4.49957 18.7499 4.49957C18.949 4.49957 19.1398 4.57863 19.2806 4.71936C19.4213 4.8601 19.5003 5.05097 19.5003 5.24999C19.5003 5.44901 19.4213 5.63988 19.2806 5.78061L13.0602 12L19.2806 18.2194Z"
                fill="#1C1C1C"
              />
            </svg>
          </div>
        </div>
        <DialogContent sx={{ backgroundColor: WHITE.W_100 }}>
          <div className="flex flex-col items-start self-stretch">
            {matricesDataDrawer?.length > 0 &&
              matricesDataDrawer?.map((m: Matrice) => (
                <div
                  className="flex justify-between items-center h-[40px] p-4 gap-2 self-stretch"
                  key={m?.matrice_name}
                  draggable
                  onDragStart={() => handleDragStart(m)}
                  onDragOver={handleDragOver}
                  onDrop={() => {
                    const updated = handleDrop(m, matricesDataDrawer);
                    if(updated){
                      setMatricesDataDrawer(updated);
                    }
                  }}
                >
                  <div className="flex items-center gap-1">
                    <img
                      src={DragAndDropIcon}
                      alt="Drag And Drop Icon"
                      style={{ cursor: "pointer" }}
                    />
                    <div
                      className=""
                      style={{
                        fontFamily: "Inter",
                        paddingLeft: "5px",
                        color: "#1C1C1E",
                        fontSize: "12px",
                        fontWeight: m?.toggle ? "600" : "400",
                        lineHeight: "18px",
                      }}
                    >
                      {m?.matrice_name}
                    </div>
                  </div>
                  <Switch
                    checked={m?.toggle}
                    onChange={() => {
                      const updated = handleSwitchChange(m?.id, matricesDataDrawer);
                      if (updated) {
                        setMatricesDataDrawer(updated);
                      }
                    }}
                  />
                </div>
              ))}
          </div>
        </DialogContent>
         <div
                                  className="h-[68px] w-full p-4 flex gap-6 justify-center items-center"
                                  style={{
                                    borderTop: "1px solid #EAEAED",
                                    backgroundColor: WHITE.W_100,
                                  }}
                                >
                                  <Button
                                    sx={{
                                      backgroundColor: "#FFF",
                                      ":hover": {
                                        backgroundColor: "#FFF",
                                      },
                                      borderRadius: "4px",
                                      paddingX: "6px",
                                      width: "50%",
                                      paddingY: "0px",
                                      border: `1px solid #EAEAED`,
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      fontFamily: "inter",
                                      fontSize: "12px",
                                      fontWeight: 700,
                                      lineHeight: "18px",
                                      color: resetToggle ? "#1C1C1E" : "#B7B7B9",
                                      '&.Mui-disabled': {
                                                        backgroundColor: 'white',  // Change this to the desired color
                                                        color: "#B7B7B9"
                                                      },
                                    }}
                                    onClick={() => onResetColumnsHandler('FIRST')}
                                    disabled={!resetToggle}
                                  >
                                    Reset Columns
                                  </Button>
                        
                                  <Button
                                    onClick={() => columnsApply('FIRST')}
                                    sx={{
                                      height: "36px",
                                      width: "50%",
                                      backgroundColor: "#1565C0",
                                      color: "#FFF",
                                      borderRadius: "4px",
                                      padding: "0px 6px",
                                      fontSize: "12px",
                                      fontWeight: 700,
                                      lineHeight: "18px",
                                    }}
                                    loading={loading}
                                  >
                                    Apply
                                  </Button>
                                </div>
      </Drawer>

      <Drawer
        key={"right"}
        anchor={"right"}
        open={metricsToggle}
        size="md"
        slotProps={{
          backdrop: {
            sx: {
              backdropFilter: "none", // Disable the blur effect
            },
          },
        }}
      >
        <div
          className="flex p-4 items-center justify-between gap-10"
          style={{
            height: 52,
            borderBottom: `1px solid #EAEAED`,
            backgroundColor: "white",
          }}
        >
          <div
            className="self-stretch"
            style={{
              fontSize: 18,
              fontWeight: 500,
              lineHeight: "24px",
              color: BLACK.B_100,
            }}
          >
            Metrics
          </div>
          <div
            className="w-fit cursor-pointer"
            onClick={() =>{
                setMatricesDataDrawer2([...metricsData2]);
                setMetricsToggle(false);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M19.2806 18.2194C19.3502 18.289 19.4055 18.3718 19.4432 18.4628C19.4809 18.5539 19.5003 18.6514 19.5003 18.75C19.5003 18.8485 19.4809 18.9461 19.4432 19.0372C19.4055 19.1282 19.3502 19.2109 19.2806 19.2806C19.2109 19.3503 19.1281 19.4056 19.0371 19.4433C18.9461 19.481 18.8485 19.5004 18.7499 19.5004C18.6514 19.5004 18.5538 19.481 18.4628 19.4433C18.3717 19.4056 18.289 19.3503 18.2193 19.2806L11.9999 13.0603L5.78055 19.2806C5.63982 19.4213 5.44895 19.5004 5.24993 19.5004C5.05091 19.5004 4.86003 19.4213 4.7193 19.2806C4.57857 19.1399 4.49951 18.949 4.49951 18.75C4.49951 18.551 4.57857 18.3601 4.7193 18.2194L10.9396 12L4.7193 5.78061C4.57857 5.63988 4.49951 5.44901 4.49951 5.24999C4.49951 5.05097 4.57857 4.8601 4.7193 4.71936C4.86003 4.57863 5.05091 4.49957 5.24993 4.49957C5.44895 4.49957 5.63982 4.57863 5.78055 4.71936L11.9999 10.9397L18.2193 4.71936C18.36 4.57863 18.5509 4.49957 18.7499 4.49957C18.949 4.49957 19.1398 4.57863 19.2806 4.71936C19.4213 4.8601 19.5003 5.05097 19.5003 5.24999C19.5003 5.44901 19.4213 5.63988 19.2806 5.78061L13.0602 12L19.2806 18.2194Z"
                fill="#1C1C1C"
              />
            </svg>
          </div>
        </div>
        <DialogContent sx={{ backgroundColor: WHITE.W_100 }}>
          <div className="flex flex-col items-start self-stretch">
            {matricesDataDrawer2?.length > 0 &&
              matricesDataDrawer2?.map((m: Matrice) => (
                <div
                  className="flex justify-between items-center h-[40px] p-4 gap-2 self-stretch"
                  key={m?.matrice_name}
                  draggable
                  onDragStart={() => handleDragStart(m)}
                  onDragOver={handleDragOver}
                  onDrop={() =>{ 
                    const updated = handleDrop(m, matricesDataDrawer2);
                    if(updated){
                      setMatricesDataDrawer2(updated);
                    }
                  }}
                >
                  <div className="flex items-center gap-1">
                    <img
                      src={DragAndDropIcon}
                      alt="Drag And Drop Icon"
                      style={{ cursor: "pointer" }}
                    />
                    <div
                      className=""
                      style={{
                        fontFamily: "Inter",
                        paddingLeft: "5px",
                        color: "#1C1C1E",
                        fontSize: "12px",
                        fontWeight: m?.toggle ? "600" : "400",
                        lineHeight: "18px",
                      }}
                    >
                      {m?.matrice_name}
                    </div>
                  </div>
                  <Switch
                    checked={m?.toggle}
                    onChange={() => {
                      const updated = handleSwitchChange(m?.id, matricesDataDrawer2);
                      if (updated) {
                        setMatricesDataDrawer2(updated);
                      }
                    }}
                  />
                </div>
              ))}
          </div>
        </DialogContent>
         <div
          className="h-[68px] w-full p-4 flex gap-6 justify-center items-center"
          style={{
            borderTop: "1px solid #EAEAED",
            backgroundColor: WHITE.W_100,
          }}
        >
          <Button
            sx={{
              backgroundColor: "#FFF",
              ":hover": {
                backgroundColor: "#FFF",
              },
              borderRadius: "4px",
              paddingX: "6px",
              width: "50%",
              paddingY: "0px",
              border: `1px solid #EAEAED`,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontFamily: "inter",
              fontSize: "12px",
              fontWeight: 700,
              lineHeight: "18px",
              color: resetToggle ? "#1C1C1E" : "#B7B7B9",
              '&.Mui-disabled': {
                                backgroundColor: 'white',  // Change this to the desired color
                                color: "#B7B7B9"
                              },
            }}
            onClick={() => onResetColumnsHandler('SECOND')}
            disabled={!resetToggle}
          >
            Reset Columns
          </Button>

          <Button
            onClick={() => columnsApply("SECOND")}
            sx={{
              height: "36px",
              width: "50%",
              backgroundColor: "#1565C0",
              color: "#FFF",
              borderRadius: "4px",
              padding: "0px 6px",
              fontSize: "12px",
              fontWeight: 700,
              lineHeight: "18px",
            }}
            loading={loading}
          >
            Apply
          </Button>
        </div>
      </Drawer>

      {
        customExportToggle && (
          <OverviewSummaryCustomExportModal
          setToggle={setCustomExportToggle}
          ip_maxminRange={range}
          ip_filter={filter}
          ip_years={years}
          ip_months={months}
          ip_weeks={weeks}
          ip_transposeFormat={transposeFormat}
          matricesData={matricesData}
          exportfunc={exportCustomHandler}
          loading={exportLoading}
        />
        )
      }
    </>
  );
};

export default OverviewSummaryPage;
